import React, { useState, useRef, useEffect, useLayoutEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import * as Tooltip from '@radix-ui/react-tooltip';

import { trackEvent } from '../../lib/analytics';

// eslint-disable-next-line
import {
    toggleVisibilityContextMenu,
    showContextMenu,
    // hideContextMenu,
    moveColumnBelow,
    moveColumnAbove,
    addNewColumnAbove,
    addNewColumnBelow,
    addNewFirstColumn,
    addNewColumnInTheEnd,
    addNewColumnInTheStart,
    deleteColumn,
    setColumnIndex,
    setColumnNN,
    setColumnAutoIncrement,

    setColumnEnum,
    setColumnDefaultValue,

    setColumnGeneratedValue,
    setColumnCheckValue,

    setColumnDescription,
    setElementDescription,
    setAreaDescription,
    setLineDescription,

    setLineOnTrigger,

    setColumnKey,
    setLineConnectorsReversed,
    setLineConnector,
    setLineSolidType,
    // showTablesChanges,
    duplicateElements,
    deleteElements,
    duplicateFocusedGroup,
    deleteFocusedGroup,
    duplicateFocusedArea,
    deleteFocusedArea,

    duplicateColumn,

    // autoResizeElements,
    toggleBtnNewLine,
    deleteLine,
    setElementsBorder,
    setAreaBorder,
    setElementsColor,
    setLineColor,
    setAreaColor,
    addNewAreaForFocusedElements,
    setNoteAlignment,
    setNoteFontMonospace,
    setNoteFontStyle,
    // clickEscape,
    enableElementDescriptionEditing,
    disableElementDescriptionEditing,
} from '../../redux/diagram/diagram.actions';

// eslint-disable-next-line
import {
    selectFocusedInsideElement,
    selectIsContextMenuShowed,
    selectIsContextMenuVisible,
    selectFocusedElements,
    selectFocusedGroupElements,
    selectFocusedGroupAreas,
    selectFocusedLine,
    selectFocusedArea,
    selectThemeMode,
    selectIsBtnNewLineEnabled,
    selectViewMode,
    selectIsBtnPopupNewsEnabled,
} from '../../redux/diagram/diagram.selectors';

import {
    selectIsModalSupportEnabled,
    selectIsModalDiagramDetailsEnabled,
} from '../../redux/main/main.selectors';

// eslint-disable-next-line
import {
    TableGroupNewSmallIcon,
    ElementDescriptionIcon,
    DragMenuIcon,
    VisibilityNewIcon,
    // VisibilityIcon,
    DraggableColumnsIcon,
    DraggableColumnsReverseIcon,
    ShowMenuIcon,
    // HideMenuIcon,
    MarkYesIcon,
    MarkNoIcon,
    CircleNoneIcon,
    KeyIcon,
    CommentIconNew,
    // DragColumnIcon,
    // LineIcon,
    LineIconNewSmall,
    // FitToZoomIcon,
    // AutoLayoutIcon,
    CopyIcon,
    InsertAfterIcon,
    InsertBeforeIcon,
    DeleteIcon,
    // TableDarkIcon,
    // TableLightIcon
    // SwapLinesIcon,
    SwapLinesIconNew,
    LineConnectorEmptyIcon,
    LineConnectorOneIcon,
    LineConnectorManyIcon,
    LineConnectorOneNullIcon,
    LineConnectorManyNullIcon,
    LineTypeIcon,
    ElementBorderIcon,
    // LineTypeDashesIcon,
    BackgroundColorCircleIcon,
    FontMonospaceIcon,
    NoteSmallIcon,
    AlignLeftIcon,
    AlignRightIcon,
    AlignCenterIcon,
    AlignTopIcon,
    AlignBottomIcon,
    AlignVerticalCenterIcon,
    LinkIcon,
    BoldTextIcon,
    ItalicTextIcon,
    UnderlineTextIcon,
    StrikethroughTextIcon,
    TagIcon,
    OkCheckIcon,
    TriggerIcon,
    GeneratedColumnIcon,
    CheckExpressionIcon,
} from '../Icon';

import { useShortKeysNavigation } from '../../hooks/useShortKeysNavigation';

import './ContextMenu.scss';

function getLineConnector(relationType, isLeft = false) {
    switch (relationType) {
        case 'empty': {
            return <LineConnectorEmptyIcon />;
        }
        case 'one': {
            return <LineConnectorOneIcon isLeft={isLeft} />;
        }
        case 'many': {
            return <LineConnectorManyIcon isLeft={isLeft} />;
        }
        case 'one-null': {
            return <LineConnectorOneNullIcon isLeft={isLeft} />;
        }
        case 'many-null': {
            return <LineConnectorManyNullIcon isLeft={isLeft} />;
        }
        default:
            return <LineConnectorEmptyIcon />;
    }
}

// TODO: use coordinates from focused elements from Redux, not from canvas props, couse when you create new element with grabbing and have focused elements before => context menu stay at previous focused elements, not at new element
export const ContextMenu = ({ elementY, elementX, elementWidth, elementHeight, elementCenterX, left, top, isFocusedInsideElementEmpty }) => {
    const dispatch = useDispatch();

    const { t, i18n } = useTranslation();

    const { map: shortKeysMap, isMac } = useShortKeysNavigation();

    const [clickedItem, setClickedItem] = useState(null);

    const [isBtnDragMenuPressed, setIsBtnDragMenuPressed] = useState(false);
    const dragMenuRef = useRef(null);
    const dragMenuStartXYRef = useRef({ x: 0, y: 0 });
    // const dragMenuDxDyRef = useRef({ dx: 0, dy: 0 });
    const [dragMenuDxDy, setDragMenuDxDy] = useState({ dx: 0, dy: 0 });


    const [isMoreBtnClicked, setIsMoreBtnClicked] = useState(false);

    const themeMode = useSelector(selectThemeMode);


    const isModalSupportEnabled = useSelector(selectIsModalSupportEnabled);
    const isModalDiagramDetailsEnabled = useSelector(selectIsModalDiagramDetailsEnabled);

    const isBtnPopupNewsEnabled = useSelector(selectIsBtnPopupNewsEnabled);

    const isBtnNewLineEnabled = useSelector(selectIsBtnNewLineEnabled);

    const boardViewMode = useSelector(selectViewMode);
    const isContextMenuShowed = useSelector(selectIsContextMenuShowed);

    const isContextMenuVisible = useSelector(selectIsContextMenuVisible);


    const focusedElements = useSelector(selectFocusedElements);

    const focusedGroupElements = useSelector(selectFocusedGroupElements);
    const focusedGroupAreas = useSelector(selectFocusedGroupAreas);

    const focusedLine = useSelector(selectFocusedLine);
    const focusedArea = useSelector(selectFocusedArea);

    const focusedInsideElement = useSelector(selectFocusedInsideElement);

    const focusedInsideElementRef = useRef(null);

    const focusedElementsRef = useRef(null);

    const [focusedInsideElementState, setFocusedInsideElement] = useState(null);

    const menuRef = useRef();

    const enumBtnRef = useRef(null);
    const defaultValueBtnRef = useRef(null);
    const generatedValueBtnRef = useRef(null);
    const checkValueBtnRef = useRef(null);

    const columnDescriptionBtnRef = useRef(null);



    const descriptionMenuInputRef = useRef(null);
    const descriptionMenuButtonRef = useRef(null);

    const enumValueMenuInputRef = useRef(null);
    const enumValueMenuButtonRef = useRef(null);

    const defaultValueMenuInputRef = useRef(null);
    const defaultValueMenuButtonRef = useRef(null);

    const generatedValueMenuInputRef = useRef(null);
    const generatedValueMenuButtonRef = useRef(null);

    const checkValueMenuInputRef = useRef(null);
    const checkValueMenuButtonRef = useRef(null);


    const [viewMode, setViewMode] = useState(null);
    const [isHovered, setIsHovered] = useState(false);

    // const rombRadius = 9;
    const rombRadius = 9.25;

    let contextMenuWidth =
        // viewMode === 'pen-segment' ? 339
        viewMode === 'pen-segment' ? 255
            : viewMode === 'note' ? 636
                : viewMode === 'column'
                    ? isMoreBtnClicked ? 871 : 680
                    : viewMode === 'table' ? 346
                        : viewMode === 'area' ? 436
                            : viewMode === 'line' ? 664
                                : viewMode === 'group' ? 286
                                    : 438;


    const elementStartX = elementX;
    const elementEndX = elementX + elementWidth;
    const elementEndY = elementY + elementHeight;

    let newElementCenterX = elementCenterX;

    if (elementStartX < 0) {
        newElementCenterX = (0 + elementEndX) / 2;
    }

    if (elementEndX > window.innerWidth) {
        newElementCenterX = (elementStartX + window.innerWidth) / 2;
    }

    if (elementStartX < 0 && elementEndX > window.innerWidth) {
        newElementCenterX = (0 + window.innerWidth) / 2;
    }


    const isNotElementInViewPort =
        elementStartX > window.innerWidth ||
        elementEndX < 0 ||
        elementY > window.innerHeight ||
        elementEndY < 0;


    // const topMin = 70;
    const topMin = isBtnPopupNewsEnabled ? 70 + 54 : 70;
    let topOptimal = top < topMin ? topMin : top;

    const leftMin = 70;
    const leftMax = window.innerWidth - contextMenuWidth - 15;

    let positionLeft = newElementCenterX - (contextMenuWidth / 2) - 1;

    positionLeft = positionLeft < leftMin ? leftMin : positionLeft;
    positionLeft = positionLeft + contextMenuWidth > window.innerWidth ? leftMax : positionLeft;

    const positionMenuStyle = {
        left: `${positionLeft + dragMenuDxDy.dx || 0}px`,
        top: `${topOptimal + dragMenuDxDy.dy || 0}px`,
    };

    // show menu button
    const wrappedMenu = (
        <div
            className={`menu`}
            style={{ left: `${positionLeft || 0}px`, top: `${topOptimal || 0}px` }}
        >
            <div className="controls-group">
                <div className="control">
                    <button
                        className="control-button"
                        type="button"
                        title="0-Movable Columns"
                        aria-label="0-Movable Columns"
                        aria-pressed="false"
                        onClick={() => dispatch(showContextMenu({}))}
                    >
                        <ShowMenuIcon />
                    </button>
                </div>
            </div>
        </div>
    );

    // hide menu button
    // const HideMenuPart = <div className="control">
    // 	<button
    // 		className='control-button'
    // 		type="button"
    // 		title="0-Movable Columns"
    // 		aria-label="0-Movable Columns"
    // 		aria-pressed="false"
    // 		onClick={() => dispatch(hideContextMenu())}
    // 	>
    // 		<HideMenuIcon />
    // 	</button>
    // </div>;

    // visibility/opacity menu button
    const VisibilityMenuPart = (
        <div className="control">
            <Tooltip.Root delayDuration={600} disableHoverableContent>
                <Tooltip.Trigger asChild>
                    <button
                        className={`control-button visibility-btn ${!isContextMenuVisible ? 'selected' : ''}`}
                        type="button"
                        aria-pressed="false"
                        onClick={() => {
                            const action = isContextMenuVisible ? 'hide' : 'show';
                            trackEvent(`playground_ctx_${action}_menu`, {
                                page: 'playground',
                                type: 'context',
                                subtype: 'all',
                            });
                            dispatch(toggleVisibilityContextMenu())
                        }}
                    >
                        <VisibilityNewIcon />
                    </button>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content
                        className="tooltip-content tooltip-controls wo-shortcut"
                        side="top"
                        align="center"
                        sideOffset={10}
                    >
                        <span>
                            {isContextMenuVisible
                                ? t('t.ctx.base.hide_menu')
                                : t('t.ctx.base.show_menu')}
                        </span>
                        {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root>
        </div>
    );

    // drag menu button
    const DragMenuPart = (
        <div className="control drag-menu">
            {/* <Tooltip.Root delayDuration={600} disableHoverableContent>
                <Tooltip.Trigger asChild> */}
            <button
                ref={dragMenuRef}
                className={`control-button ${isBtnDragMenuPressed || (dragMenuDxDy.dx || dragMenuDxDy.dy) ? 'selected' : ''}`}
                type="button"
                aria-pressed="false"
                onClick={() => {
                    trackEvent('playground_ctx_drag_menu', {
                        page: 'playground',
                        type: 'context',
                        subtype: 'all',
                    });
                }}
                style={{ width: '24px' }}
            >
                <DragMenuIcon />
            </button>
            {/* </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content
                        className="tooltip-content tooltip-controls"
                        side="top"
                        align="center"
                        sideOffset={10}
                    >
                        <span>Drag Menu</span>

                        <Tooltip.Arrow className="tooltip-arrow" />
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root> */}
        </div>
    );

    // NOTE MENU
    // + drag menu
    // -----------------
    //4 + type/size (/NOTIFICATION/REMINDER/MESSAGE/TODO/NOTE/question/description/need decision/change request/need review)
    // - size (S/M/L)
    // -----------------
    // - font (inte/roboto/monospace/etc)
    // - font-size (14 + <|>)
    // -----------------
    // + font-style (bold/italic/underscore/crosscore/etc)
    // + font-monospace
    // + alignment (left/center/right)
    // -----------------
    // + background-color
    // + border
    // -----------------
    //3 + link (insert link)
    //3 + tags
    // -----------------
    // - author (author name - hide/show) (with avatar/without)
    // - date (show date/time)
    // - add emoji/reaction (likes/smiles/weird/new-img-symbols)
    // -----------------
    // + comment
    // + copy
    // + delete
    // + hide menu

    // note menu
    const getNoteMenu = (focusedElements) => {
        const keys = Object.keys(focusedElements);

        if (!keys.length) {
            return;
        }

        const note = focusedElements[keys[0]];
        const {
            value: { border, color },
        } = note;
        let colorCounter = {
            none: 0,
            blue: 0,
            green: 0,
            red: 0,
            purple: 0,
            violet: 0,
        };

        if (!color) {
            colorCounter.none++;
        } else {
            colorCounter[color]++;
        }

        const colorName = colorCounter.blue
            ? 'blue'
            : colorCounter.green
                ? 'green'
                : colorCounter.red
                    ? 'red'
                    : colorCounter.purple
                        ? 'purple'
                        : colorCounter.violet
                            ? 'violet'
                            : null;

        return (
            <div className={`menu`} >
                <div className="controls-group">
                    {DragMenuPart}
                    <div className="control-divider"></div>

                    {/* type */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_type', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick();
                                    }}
                                >
                                    <NoteSmallIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Type</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* font style */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${clickedItem == 'font-styles' ? 'clicked' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_font_style', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick('font-styles');
                                    }}
                                >
                                    <BoldTextIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Font Style</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* Font Monospace */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${note.value.isFontMonospace ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_font_monospace', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick();
                                        dispatch(setNoteFontMonospace(note.id));
                                    }}
                                >
                                    <FontMonospaceIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Font Monospace</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* font size
					<Tooltip.Root delayDuration={600} disableHoverableContent>
						<Tooltip.Trigger asChild>

							<div className="control">
								<button
									className='control-button'
									type="button"
									aria-pressed="false"
									onClick={() => {
										handleMenuClick('element-borders');
									}}
								>
									Font Size
								</button>
							</div>
						</Tooltip.Trigger>
						<Tooltip.Portal>
							<Tooltip.Content
								className="tooltip-content tooltip-controls"
								side="top"
								align="center"
								sideOffset={10}
							>
								<span>Font Size</span>

								<Tooltip.Arrow className="tooltip-arrow" />
							</Tooltip.Content>
						</Tooltip.Portal>
					</Tooltip.Root> */}

                    {/* alignment */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button
                                        ${(['center', 'right'].includes(note.value.alignmentHorizontal) || ['center', 'bottom'].includes(note.value.alignmentVertical)) ? 'selected' : ''}
                                        ${clickedItem == 'align' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_align', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick('align');
                                    }}
                                >
                                    {note.value.alignmentHorizontal ===
                                        'right' ? (
                                        <AlignRightIcon />
                                    ) : note.value.alignmentHorizontal ===
                                        'center' ? (
                                        <AlignCenterIcon />
                                    ) : (
                                        <AlignLeftIcon />
                                    )}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Alignment</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* link */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_link', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick();
                                    }}
                                >
                                    <LinkIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Link</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* tags */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_tag', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick();
                                    }}
                                >
                                    <TagIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Tags</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* author
					<Tooltip.Root delayDuration={600} disableHoverableContent>
						<Tooltip.Trigger asChild>

							<div className="control">
								<button
									className='control-button'
									type="button"
									aria-pressed="false"
									onClick={() => {
										handleMenuClick('element-borders');
									}}
								>
									Author
								</button>
							</div>
						</Tooltip.Trigger>
						<Tooltip.Portal>
							<Tooltip.Content
								className="tooltip-content tooltip-controls"
								side="top"
								align="center"
								sideOffset={10}
							>
								<span>Author</span>

								<Tooltip.Arrow className="tooltip-arrow" />
							</Tooltip.Content>
						</Tooltip.Portal>
					</Tooltip.Root> */}

                    {/* date
					<Tooltip.Root delayDuration={600} disableHoverableContent>
						<Tooltip.Trigger asChild>

							<div className="control">
								<button
									className='control-button'
									type="button"
									aria-pressed="false"
									onClick={() => {
										handleMenuClick('element-borders');
									}}
								>
									Date
								</button>
							</div>
						</Tooltip.Trigger>
						<Tooltip.Portal>
							<Tooltip.Content
								className="tooltip-content tooltip-controls"
								side="top"
								align="center"
								sideOffset={10}
							>
								<span>Date</span>

								<Tooltip.Arrow className="tooltip-arrow" />
							</Tooltip.Content>
						</Tooltip.Portal>
					</Tooltip.Root> */}

                    {/* reaction
					<Tooltip.Root delayDuration={600} disableHoverableContent>
						<Tooltip.Trigger asChild>

							<div className="control">
								<button
									className='control-button'
									type="button"
									aria-pressed="false"
									onClick={() => {
										handleMenuClick('element-borders');
									}}
								>
									Reaction
								</button>
							</div>
						</Tooltip.Trigger>
						<Tooltip.Portal>
							<Tooltip.Content
								className="tooltip-content tooltip-controls"
								side="top"
								align="center"
								sideOffset={10}
							>
								<span>Reaction</span>

								<Tooltip.Arrow className="tooltip-arrow" />
							</Tooltip.Content>
						</Tooltip.Portal>
					</Tooltip.Root> */}

                    <div className="control-divider"></div>


                    {/* color-picker */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`
                                        control-button
                                        ${colorName ? 'selected' : ''}
                                        ${clickedItem == 'color-picker' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_color', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick('color-picker');
                                    }}
                                >
                                    <BackgroundColorCircleIcon color={colorName || 'grey'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.color')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* border */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`
                                        control-button line-connector border
                                        ${note?.value?.border ? 'selected' : ''}
                                        ${clickedItem == 'element-borders' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_border', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick('element-borders');
                                    }}
                                >
                                    <ElementBorderIcon
                                        isDashes={note?.value?.border === 'dashes'}
                                        isDots={note?.value?.border === 'dots'}
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.border')}</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* description */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${note.value?.description ? 'selected' : ''} ${clickedItem == 'note-description' ? 'clicked' : ''} `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_description', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick('note-description');
                                    }}
                                >
                                    <ElementDescriptionIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.description')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* copy */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_duplicate', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick();
                                        dispatch(duplicateElements());
                                    }}
                                >
                                    <CopyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.duplicate')}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + C
                                </span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* delete */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${clickedItem === 'delete-element' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_delete', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note',
                                        });
                                        handleMenuClick();
                                        dispatch(deleteElements({}));
                                    }}
                                >
                                    <DeleteIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.delete')}</span>
                                <span className="tooltip-shortcut">Del</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {VisibilityMenuPart}
                </div>
            </div>
        );
    };

    // table menu
    const getTableMenu = (focusedElements) => {
        const keys = Object.keys(focusedElements);

        if (!keys.length) {
            return;
        }

        const table = focusedElements[keys[0]];
        const { value: { border, color } } = table;

        let colorCounter = {
            none: 0,
            blue: 0,
            green: 0,
            red: 0,
            purple: 0,
            violet: 0,
        };

        if (!color) {
            colorCounter.none++;
        } else {
            colorCounter[color]++;
        }

        const colorName = colorCounter.blue
            ? 'blue'
            : colorCounter.green
                ? 'green'
                : colorCounter.red
                    ? 'red'
                    : colorCounter.purple
                        ? 'purple'
                        : colorCounter.violet
                            ? 'violet'
                            : null;

        return (
            <div className={`menu`} >
                <div className="controls-group">
                    {DragMenuPart}
                    <div className="control-divider"></div>

                    {/* Key */}
                    {/* <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button
                                    ${(focusedInsideElementRef.current?.insideElement?.isPK || focusedInsideElementRef.current?.insideElement?.isFK) ? 'selected' : ''}
                                    ${clickedItem == 'key' ? 'clicked' : ''}
                                `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        handleMenuClick('key');
                                    }}
                                >
                                    <KeyIcon
                                        isDark={!themeMode}
                                        isPK={
                                            focusedInsideElementRef.current
                                                ?.insideElement?.isPK
                                        }
                                        isFK={
                                            focusedInsideElementRef.current
                                                ?.insideElement?.isFK
                                        }
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Key</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + 1
                                </span>

                                <Tooltip.Arrow className="tooltip-arrow" />
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root> */}

                    {/* Index */}
                    {/* <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button index
                                    ${focusedInsideElementRef.current?.insideElement?.index?.type ? 'selected' : ''}
                                    ${clickedItem == 'index' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        handleMenuClick('index');
                                    }}
                                >
                                    <svg
                                        className={`context-menu-column-index ${focusedInsideElementRef.current?.insideElement?.index?.type} ${focusedInsideElementRef.current?.insideElement?.index?.type ? 'selected' : ''}`}
                                    >
                                        <polygon
                                            points={`${rombRadius + 1},1 ${rombRadius * 2 + 1
                                                },${rombRadius + 1} ${rombRadius + 1},${rombRadius * 2 + 1
                                                } 1,${rombRadius + 1}`}
                                        />
                                    </svg>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Index</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + 2
                                </span>

                                <Tooltip.Arrow className="tooltip-arrow" />
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root> */}

                    {/* <div className="control-divider"></div> */}


                    {/* Indexes */}

                    {/* Migration */}


                    {/* color-picker */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`
                                        control-button
                                        ${colorName ? 'selected' : ''}
                                        ${clickedItem == 'color-picker' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_table_color', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'table',
                                        });
                                        handleMenuClick('color-picker');
                                    }}
                                >
                                    <BackgroundColorCircleIcon color={colorName || 'grey'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.color')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* border */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`
                                        control-button line-connector border
                                        ${table?.value?.border ? 'selected' : ''}
                                        ${clickedItem == 'element-borders' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_table_border', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'table',
                                        });
                                        handleMenuClick('element-borders');
                                    }}
                                >
                                    <ElementBorderIcon
                                        isDashes={table?.value?.border === 'dashes'}
                                        isDots={table?.value?.border === 'dots'}
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.border')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* Description */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${table.value?.description ? 'selected' : ''} ${clickedItem == 'table-description' ? 'clicked' : ''} `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_table_description', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'table',
                                        });
                                        handleMenuClick('table-description');
                                    }}
                                >
                                    <ElementDescriptionIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.description')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>


                    {/* Auto Layout element */}

                    {/*
                        <div className="control">
                            <button
                                className='control-button'
                                type="button"
                                title="2-Auto Layout"
                                aria-label="Auto Layout"
                                aria-pressed="false"
                                onClick={() => dispatch(showTablesChanges({}))}
                            >
                                <AutoLayoutIcon />
                            </button>
                        </div>
                    */}

                    {/* Auto Resize element */}
                    {/* show only if table is already resized */}

                    {/*
                        <div className="control">
                            <button
                                className='control-button'
                                type="button"
                                title="Auto Resize"
                                aria-label="Auto Resize"
                                aria-pressed="false"
                                onClick={() => dispatch(autoResizeElements())}
                            >
                                <FitToZoomIcon />
                            </button>
                        </div>
			        */}

                    {/* Duplicate */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_table_duplicate', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'table',
                                        });
                                        handleMenuClick();
                                        dispatch(duplicateElements());
                                    }}
                                >
                                    <CopyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.duplicate')}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + C</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* Delete */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${clickedItem == 'delete-element' ? 'clicked' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_table_delete', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'table',
                                        });
                                        handleMenuClick('delete-element');
                                    }}
                                >
                                    <DeleteIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.delete_confirm')}</span>
                                {focusedInsideElement && focusedInsideElement?.insideElementType === 'header'
                                    ? (<span className="tooltip-shortcut">{shortKeysMap?.CTRL} + Del</span>)
                                    : (<span className="tooltip-shortcut">Del</span>)}
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {VisibilityMenuPart}
                </div>
            </div>
        )
    };

    // multi elements menu
    const getMultiElementsMenu = (focusedElements) => {
        const elementsCount = Object.keys(focusedElements).length;
        if (!elementsCount) {
            return;
        }

        let borderCounter = { none: 0, solid: 0, dashes: 0, dots: 0 };
        let colorCounter = {
            none: 0,
            blue: 0,
            green: 0,
            red: 0,
            purple: 0,
            violet: 0,
        };

        for (let key in focusedElements) {
            const element = focusedElements[key];

            // border section
            if (!element?.value?.border) {
                borderCounter.none++;
            } else {
                borderCounter[element?.value?.border]++;
            }

            // color section
            if (!element?.value?.color) {
                colorCounter.none++;
            } else {
                colorCounter[element?.value?.color]++;
            }
        }

        const colorName =
            colorCounter.blue == elementsCount
                ? 'blue'
                : colorCounter.green == elementsCount
                    ? 'green'
                    : colorCounter.red == elementsCount
                        ? 'red'
                        : colorCounter.purple == elementsCount
                            ? 'purple'
                            : colorCounter.violet == elementsCount
                                ? 'violet'
                                : null;

        return (
            <div className={`menu`}>
                <div className="controls-group">
                    {DragMenuPart}
                    <div className="control-divider"></div>

                    {/* Filter Selection */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button filter-selection"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_multi_filter', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'multi',
                                        });
                                    }}
                                >
                                    {`${Object.keys(focusedElements).length} Element${Object.keys(focusedElements).length == 1 ? '' : 's'}`}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.multi.filter')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* Group Selection */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_multi_add_area', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'multi',
                                        });
                                        dispatch(addNewAreaForFocusedElements())
                                    }}
                                >
                                    <TableGroupNewSmallIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.multi.create_area')}</span>
                                {/* <span>Group Selection</span> */}
                                {/* <span className="tooltip-shortcut">G</span> */}
                                <span className="tooltip-shortcut">A</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* color picker */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button
                                        ${colorName ? 'selected' : ''}
                                        ${clickedItem == 'color-picker' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_multi_color', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'multi',
                                        });
                                        handleMenuClick('color-picker');
                                    }}
                                >
                                    <BackgroundColorCircleIcon color={colorName || 'grey'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.color')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* border */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector border
                                        ${(borderCounter.solid == elementsCount ||
                                            borderCounter.dashes == elementsCount ||
                                            borderCounter.dots == elementsCount) ? 'selected' : ''}
                                        ${clickedItem == 'element-borders' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_multi_border', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'multi',
                                        });
                                        handleMenuClick('element-borders');
                                    }}
                                >
                                    <ElementBorderIcon
                                        isDashes={borderCounter.dashes == elementsCount}
                                        isDots={borderCounter.dots == elementsCount}
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.border')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* duplicate */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_multi_duplicate', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'multi',
                                        });
                                        handleMenuClick();
                                        dispatch(duplicateElements());
                                    }}
                                >
                                    <CopyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.duplicate')}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + C
                                </span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* delete */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button
                                    ${clickedItem == 'delete-element' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_multi_delete', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'multi',
                                        });
                                        handleMenuClick('delete-element');
                                    }}
                                >
                                    <DeleteIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.delete_confirm')}</span>
                                <span className="tooltip-shortcut">Del</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {VisibilityMenuPart}
                </div>
            </div>
        );
    };

    // group menu (areas + elements)
    const getGroupMenu = (focusedGroupElements, focusedGroupAreas) => {
        const elementsCount = Object.keys(focusedGroupElements).length;
        const areasCount = Object.keys(focusedGroupAreas).length;
        if (!areasCount && !elementsCount) {
            return;
        }

        return (
            <div className={`menu`}>
                <div className="controls-group">
                    {DragMenuPart}
                    <div className="control-divider"></div>

                    {/* Filter Selection */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button filter-selection"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_multigroup_filter', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'multigroup',
                                        });
                                    }}
                                >
                                    {`${elementsCount + areasCount} Element${(elementsCount + areasCount) == 1 ? '' : 's'}`}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.multi.filter')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* duplicate */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_multigroup_duplicate', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'multigroup',
                                        });
                                        handleMenuClick();
                                        dispatch(duplicateFocusedGroup());
                                    }}
                                >
                                    <CopyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.duplicate')}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + C
                                </span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* delete */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button
                                    ${clickedItem == 'delete-element' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_multigroup_delete', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'multigroup',
                                        });
                                        handleMenuClick('delete-element');
                                    }}
                                >
                                    <DeleteIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.delete_confirm')}</span>
                                <span className="tooltip-shortcut">Del</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {VisibilityMenuPart}
                </div>
            </div>
        );
    };

    // pen menu
    const getPenSegmentMenu = (focusedElements) => {
        const keys = Object.keys(focusedElements);
        if (!keys.length) {
            return;
        }

        const segment = focusedElements[keys[0]];
        const {
            value: { border, color },
        } = segment;
        let colorCounter = {
            none: 0,
            blue: 0,
            green: 0,
            red: 0,
            purple: 0,
            violet: 0,
        };

        if (!color) {
            colorCounter.none++;
        } else {
            colorCounter[color]++;
        }

        const colorName = colorCounter.blue
            ? 'blue'
            : colorCounter.green
                ? 'green'
                : colorCounter.red
                    ? 'red'
                    : colorCounter.purple
                        ? 'purple'
                        : colorCounter.violet
                            ? 'violet'
                            : null;

        return (
            <div className={`menu`}>
                <div className="controls-group">

                    {DragMenuPart}

                    <div className="control-divider"></div>

                    {/* color-picker */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    disabled
                                    className={`control-button disabled
                                        ${colorName ? 'selected' : ''}
                                        ${clickedItem == 'color-picker' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_pen_color', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'pen',
                                        });
                                        handleMenuClick('color-picker');
                                    }}
                                >
                                    <BackgroundColorCircleIcon color={colorName || '#ffc65e'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.color')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* border */}
                    {/* <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    disabled
                                    className={`control-button disabled line-connector border
                                        ${segment?.value?.border ? 'selected' : ''}
                                        ${clickedItem == 'element-borders' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        handleMenuClick('element-borders');
                                    }}
                                >
                                    <ElementBorderIcon
                                        isDashes={segment?.value?.border === 'dashes'}
                                        isDots={segment?.value?.border === 'dots'}
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.border')}</span>
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root> */}

                    {/* <div className="control-divider"></div> */}

                    {/* description */}
                    {/* <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${segment.value?.description ? 'selected' : ''} ${clickedItem == 'pen-description' ? 'clicked' : ''} `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        handleMenuClick('pen-description');
                                    }}
                                >
                                    <ElementDescriptionIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.description')}</span>
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root> */}

                    <div className="control-divider"></div>

                    {/* copy */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_pen_duplicate', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'pen',
                                        });
                                        handleMenuClick();
                                        dispatch(duplicateElements());
                                    }}
                                >
                                    <CopyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.duplicate')}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + C
                                </span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* delete */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${clickedItem === 'delete-element' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_pen_delete', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'pen',
                                        });
                                        handleMenuClick();
                                        dispatch(deleteElements({}));
                                    }}
                                >
                                    <DeleteIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.delete')}</span>
                                <span className="tooltip-shortcut">Del</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {VisibilityMenuPart}
                </div>
            </div>
        );
    };

    // area menu
    const getAreaMenu = (focusedArea) => {
        if (!focusedArea) {
            return;
        }

        const {
            value: { nestedElementsIds, color },
        } = focusedArea;
        let colorCounter = {
            none: 0,
            blue: 0,
            green: 0,
            red: 0,
            purple: 0,
            violet: 0,
        };

        if (!color) {
            colorCounter.none++;
        } else {
            colorCounter[color]++;
        }

        const colorName = colorCounter.blue
            ? 'blue'
            : colorCounter.green
                ? 'green'
                : colorCounter.red
                    ? 'red'
                    : colorCounter.purple
                        ? 'purple'
                        : colorCounter.violet
                            ? 'violet'
                            : null;

        return (
            <div className={`menu`} >
                <div className="controls-group">
                    {DragMenuPart}
                    <div className="control-divider"></div>

                    {/* filter selection */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button filter-selection"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_area_filter', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'area',
                                        });
                                    }}
                                >
                                    {`${nestedElementsIds?.length || 0} Element${(nestedElementsIds?.length || 0) == 1 ? '' : 's'}`}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.area.filter')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* color-picker */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${colorName ? 'selected' : ''}
                                        ${clickedItem == 'color-picker' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_area_color', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'area',
                                        });
                                        handleMenuClick('color-picker');
                                    }}
                                >
                                    <BackgroundColorCircleIcon color={colorName || 'grey'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.color')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* border */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector border ${['dashes', 'dots'].includes(focusedArea?.value?.border) ? 'selected' : ''}
                                        ${clickedItem == 'element-borders' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_area_border', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'area',
                                        });
                                        handleMenuClick('element-borders');
                                    }}
                                >
                                    <ElementBorderIcon
                                        isDashes={focusedArea?.value?.border === 'dashes'}
                                        isDots={focusedArea?.value?.border === 'dots'}
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.border')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* description */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${focusedArea.value?.description ? 'selected' : ''} ${clickedItem == 'area-description' ? 'clicked' : ''} `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_area_description', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'area',
                                        });
                                        handleMenuClick('area-description');
                                    }}
                                >
                                    <ElementDescriptionIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.description')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* copy */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_area_duplicate', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'area',
                                        });
                                        handleMenuClick();
                                        dispatch(duplicateFocusedArea());
                                    }}
                                >
                                    <CopyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.duplicate')}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + C
                                </span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* delete */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_area_delete', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'area',
                                        });
                                        handleMenuClick();
                                        dispatch(deleteFocusedArea());
                                    }}
                                >
                                    <DeleteIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.delete')}</span>
                                <span className="tooltip-shortcut">Del</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {VisibilityMenuPart}
                </div>
            </div>
        );
    };

    // column menu
    const getColumnMenu = () => {
        if (!focusedInsideElementRef.current || !focusedInsideElement) {
            return;
        }

        const column = focusedInsideElementRef.current;

        if (!column?.elementId || !column?.insideElementId) {
            return;
        }

        const isMoreOptionSelected =
            column?.insideElement?.generatedValue ||
            column?.insideElement?.checkValue;

        return (
            <div className={`menu`} >
                <div className="controls-group">
                    {DragMenuPart}
                    <div className="control-divider"></div>

                    {/* add column below */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_add_col_below', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick();
                                        dispatch(addNewColumnBelow(column?.elementId, column?.insideElementId));
                                    }}
                                >
                                    <InsertBeforeIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.add_col_below')}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + Enter
                                </span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* add column above */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_add_col_above', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick();
                                        dispatch(addNewColumnAbove(column?.elementId, column?.insideElementId));
                                    }}
                                >
                                    <InsertAfterIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.add_col_above')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* key */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control margin-right-small">
                                <button
                                    className={`control-button
                                    ${(column?.insideElement?.isPK || column?.insideElement?.isFK) ? 'selected' : ''}
                                    ${clickedItem == 'key' ? 'clicked' : ''}
                                `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_key', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick('key');
                                    }}
                                >
                                    <KeyIcon
                                        isDark={!themeMode}
                                        isPK={column?.insideElement?.isPK}
                                        isFK={column?.insideElement?.isFK}
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.key')}</span>
                                {/* <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + 1
                                </span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + 2
                                </span> */}

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* index */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control margin-left-small">
                                <button
                                    className={`control-button index
                                    ${column?.insideElement?.index?.type ? 'selected' : ''}
                                    ${clickedItem == 'index' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_index', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick('index');
                                    }}
                                >
                                    <svg className={`context-menu-column-index ${column?.insideElement?.index?.type} ${column?.insideElement?.index?.type ? 'selected' : ''}`} >
                                        <polygon
                                            points={`${rombRadius + 1},1 ${rombRadius * 2 + 1},${rombRadius + 1} ${rombRadius + 1},${rombRadius * 2 + 1} 1,${rombRadius + 1}`}
                                        />
                                    </svg>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.index')}</span>
                                {/* <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + 2
                                </span> */}

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* auto-increment */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${column?.insideElement?.isAutoIncrement ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_increment', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick();
                                        dispatch(setColumnAutoIncrement(column?.elementId, column?.insideElementId));
                                    }}
                                >
                                    <div className={`context-menu-column-not-null autoincrement ${column?.insideElement?.isAutoIncrement ? 'selected' : ''}`} >
                                        <span>+</span>
                                    </div>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.increment')}</span>
                                {/* <span className="tooltip-shortcut">{shortKeysMap?.CTRL} + 3</span> */}

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* enum */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    ref={enumBtnRef}
                                    className={`control-button ${column?.insideElement?.isEnum ? 'selected' : ''}
                                    ${clickedItem == 'enum' ? 'clicked' : ''}
                                `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_enum', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick();
                                        handleMenuClick('enum');
                                    }}
                                >
                                    <div
                                        className={`context-menu-column-not-null enum
                                        ${column?.insideElement?.isEnum ? 'selected' : ''}
                                        ${clickedItem == 'enum' ? 'clicked' : ''}
                                    `}
                                    >
                                        <span>E</span>
                                    </div>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.enum')}</span>
                                {/* <span className="tooltip-shortcut">{shortKeysMap?.CTRL} + 4</span> */}

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* not null */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${column?.insideElement?.isNN ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_not_null', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick();
                                        dispatch(setColumnNN(column?.elementId, column?.insideElementId));
                                    }}
                                >
                                    <div className={`context-menu-column-not-null ${column?.insideElement?.isNN ? 'selected' : ''}`}>
                                        <span>NN</span>
                                    </div>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.not_null')}</span>
                                {/* <span className="tooltip-shortcut">{shortKeysMap?.CTRL} + 3</span> */}

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* default value */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    ref={defaultValueBtnRef}
                                    className={`control-button
                                    ${column?.insideElement?.defaultValue ? 'selected' : ''}
                                    ${clickedItem == 'default-value' ? 'clicked' : ''}
                                `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_default_value', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick();
                                        handleMenuClick('default-value');
                                    }}
                                >
                                    <div
                                        className={`context-menu-column-not-null default_value
                                        ${column?.insideElement?.defaultValue ? 'selected' : ''}
                                        ${clickedItem == 'default-value' ? 'clicked' : ''}
                                    `}
                                    >
                                        <span>D</span>
                                    </div>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.default_value')}</span>
                                {/* <span className="tooltip-shortcut">{shortKeysMap?.CTRL} + 5</span> */}

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* <div className="control-divider"></div> */}

                    {/* more functions */}
                    {
                        !isMoreBtnClicked && !isMoreOptionSelected &&

                        <Fragment>

                            <div className="control-divider"></div>

                            <Tooltip.Root delayDuration={600} disableHoverableContent>
                                <Tooltip.Trigger asChild>
                                    <div className="control">
                                        <button
                                            className={`control-button more-button`}
                                            type="button"
                                            aria-pressed="false"
                                            onClick={() => {
                                                trackEvent('playground_ctx_column_more_funs', {
                                                    page: 'playground',
                                                    type: 'context',
                                                    subtype: 'column',
                                                });
                                                handleMenuClick();
                                                setIsMoreBtnClicked(true);
                                            }}
                                        >...</button>
                                    </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                    <Tooltip.Content
                                        className="tooltip-content tooltip-controls wo-shortcut"
                                        side="top"
                                        align="center"
                                        sideOffset={10}
                                    >
                                        <span>{t('t.ctx.tab_col.more_functions')}</span>
                                        {/* <span className="tooltip-shortcut">
                                {shortKeysMap?.CTRL} + 6
                            </span> */}

                                        {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                                    </Tooltip.Content>
                                </Tooltip.Portal>
                            </Tooltip.Root>
                            <div className="control-divider"></div>
                        </Fragment>
                    }


                    {
                        (isMoreBtnClicked || isMoreOptionSelected) &&
                        <Fragment>

                            {/* Generated Value */}
                            <Tooltip.Root delayDuration={600} disableHoverableContent>
                                <Tooltip.Trigger asChild>
                                    <div className="control">
                                        <button
                                            ref={generatedValueBtnRef}
                                            className={`control-button
                                                ${column?.insideElement?.generatedValue ? 'selected' : ''}
                                                ${clickedItem == 'generated-value' ? 'clicked' : ''}
                                            `}
                                            type="button"
                                            aria-pressed="false"
                                            onClick={() => {
                                                trackEvent('playground_ctx_column_generated_value', {
                                                    page: 'playground',
                                                    type: 'context',
                                                    subtype: 'column',
                                                });
                                                handleMenuClick('generated-value');
                                            }}
                                        >
                                            {/* <GeneratedColumnIcon /> */}
                                            <div
                                                className={`context-menu-column-not-null generated_value
                                                    ${column?.insideElement?.generatedValue ? 'selected' : ''}
                                                    ${clickedItem == 'generated-value' ? 'clicked' : ''}
                                                `}
                                            >
                                                <span style={{ fontSize: '13px' }}>G</span>
                                            </div>
                                        </button>
                                    </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                    <Tooltip.Content
                                        className="tooltip-content tooltip-controls"
                                        side="top"
                                        align="center"
                                        sideOffset={10}
                                    >
                                        <span>{t('t.ctx.tab_col.generated_value')}</span>
                                        {/* <span className="tooltip-shortcut">
                                            {shortKeysMap?.CTRL} + 6
                                        </span> */}

                                        {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                                    </Tooltip.Content>
                                </Tooltip.Portal>
                            </Tooltip.Root>

                            {/* <div className="control-divider"></div> */}

                            {/* Check Expression */}
                            <Tooltip.Root delayDuration={600} disableHoverableContent>
                                <Tooltip.Trigger asChild>
                                    <div className="control">
                                        <button
                                            ref={checkValueBtnRef}
                                            className={`control-button
                                                ${column?.insideElement?.checkValue ? 'selected' : ''}
                                                ${clickedItem == 'check-value' ? 'clicked' : ''}
                                            `}
                                            type="button"
                                            aria-pressed="false"
                                            onClick={() => {
                                                trackEvent('playground_ctx_column_check_value', {
                                                    page: 'playground',
                                                    type: 'context',
                                                    subtype: 'column',
                                                });
                                                handleMenuClick('check-value');
                                            }}
                                        >
                                            <CheckExpressionIcon />
                                        </button>
                                    </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                    <Tooltip.Content
                                        className="tooltip-content tooltip-controls"
                                        side="top"
                                        align="center"
                                        sideOffset={10}
                                    >
                                        <span>{t('t.ctx.tab_col.check')}</span>
                                        {/* <span className="tooltip-shortcut">
                                            {shortKeysMap?.CTRL} + 7
                                        </span> */}

                                        {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                                    </Tooltip.Content>
                                </Tooltip.Portal>
                            </Tooltip.Root>


                            {/* On Update Trigger */}
                            {/* <Tooltip.Root delayDuration={600} disableHoverableContent>
                                <Tooltip.Trigger asChild>
                                    <div className="control">
                                        <button
                                            className={`control-button letter ${focusedInsideElementRef.current
                                                ?.insideElement?.index?.type ? 'selected' : ''}`}
                                            type="button"
                                            aria-pressed="false"
                                            onClick={() => {
                                                handleMenuClick('index');
                                            }}
                                        >
                                            <TriggerIcon />
                                        </button>
                                    </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                    <Tooltip.Content
                                        className="tooltip-content tooltip-controls"
                                        side="top"
                                        align="center"
                                        sideOffset={10}
                                    >
                                        <span>On Update / On Delete Trigger</span>
                                        <span className="tooltip-shortcut">
                                            {shortKeysMap?.CTRL} + 8
                                        </span>

                                        <Tooltip.Arrow className="tooltip-arrow" />
                                    </Tooltip.Content>
                                </Tooltip.Portal>
                            </Tooltip.Root> */}

                            <div className="control-divider"></div>

                            {/* Move Column Down */}
                            <Tooltip.Root delayDuration={600} disableHoverableContent>
                                <Tooltip.Trigger asChild>
                                    <div className="control">
                                        <button
                                            className="control-button"
                                            type="button"
                                            aria-pressed="false"
                                            onClick={() => {
                                                trackEvent('playground_ctx_column_move_down', {
                                                    page: 'playground',
                                                    type: 'context',
                                                    subtype: 'column',
                                                });
                                                handleMenuClick();
                                                dispatch(moveColumnBelow(column?.elementId, column?.insideElementId));
                                            }}
                                        >
                                            <DraggableColumnsReverseIcon />
                                        </button>
                                    </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                    <Tooltip.Content
                                        className="tooltip-content tooltip-controls"
                                        side="top"
                                        align="center"
                                        sideOffset={10}
                                    >
                                        <span>{t('t.ctx.tab_col.move_col_down')}</span>
                                        <span className="tooltip-shortcut">
                                            {shortKeysMap?.CTRL} + Shift + Down
                                        </span>

                                        {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                                    </Tooltip.Content>
                                </Tooltip.Portal>
                            </Tooltip.Root>

                            {/* Move Column Up */}
                            <Tooltip.Root delayDuration={600} disableHoverableContent>
                                <Tooltip.Trigger asChild>
                                    <div className="control">
                                        <button
                                            className="control-button"
                                            type="button"
                                            aria-pressed="false"
                                            onClick={() => {
                                                trackEvent('playground_ctx_column_move_up', {
                                                    page: 'playground',
                                                    type: 'context',
                                                    subtype: 'column',
                                                });
                                                handleMenuClick();
                                                dispatch(moveColumnAbove(column?.elementId, column?.insideElementId));
                                            }}
                                        >
                                            <DraggableColumnsIcon />
                                        </button>
                                    </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                    <Tooltip.Content
                                        className="tooltip-content tooltip-controls"
                                        side="top"
                                        align="center"
                                        sideOffset={10}
                                    >
                                        <span>{t('t.ctx.tab_col.move_col_up')}</span>
                                        <span className="tooltip-shortcut">
                                            {shortKeysMap?.CTRL} + Shift + Up
                                        </span>

                                        {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                                    </Tooltip.Content>
                                </Tooltip.Portal>
                            </Tooltip.Root>

                            <div className="control-divider"></div>

                        </Fragment>
                    }
                    {/* description */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    ref={columnDescriptionBtnRef}
                                    className={`control-button ${focusedInsideElementRef.current?.insideElement?.description ? 'selected' : ''} ${clickedItem == 'column-description' ? 'clicked' : ''} `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_description', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick('column-description');
                                    }}
                                >
                                    <ElementDescriptionIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.description')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* duplicate */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_duplicate', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick();
                                        dispatch(duplicateColumn(column?.elementId, column?.insideElementId));
                                    }}

                                >
                                    <CopyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.duplicate')}</span>
                                <span className="tooltip-shortcut">{shortKeysMap?.CTRL} + C</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* delete */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_column_delete', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'column',
                                        });
                                        handleMenuClick();
                                        dispatch(deleteColumn(column?.elementId, column?.insideElementId));
                                    }}
                                >
                                    <DeleteIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.delete')}</span>
                                <span className="tooltip-shortcut">{shortKeysMap?.CTRL} + Del</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {VisibilityMenuPart}
                </div>
            </div>
        )
    };

    function getConnectorText(connectorType) {
        switch (connectorType) {
            case 'empty':
                return t('t.ctx.line.connects.empty');
            case 'one':
                return t('t.ctx.line.connects.one_to');
            case 'many':
                return t('t.ctx.line.connects.many_to');
            case 'one-null':
                return t('t.ctx.line.connects.one_null_to');
            case 'many-null':
                return t('t.ctx.line.connects.many_null_to');
            default:
                return t('t.ctx.line.connects.empty');
        }
    }

    // line menu
    const getLineMenu = (focusedLine) => {
        if (!focusedLine) {
            return;
        }

        let colorCounter = {
            none: 0,
            blue: 0,
            green: 0,
            red: 0,
            purple: 0,
            violet: 0,
        };
        if (!focusedLine?.value?.color) {
            colorCounter.none++;
        } else {
            colorCounter[focusedLine?.value?.color]++;
        }

        const colorName = colorCounter.blue
            ? 'blue'
            : colorCounter.green
                ? 'green'
                : colorCounter.red
                    ? 'red'
                    : colorCounter.purple
                        ? 'purple'
                        : colorCounter.violet
                            ? 'violet'
                            : null;

        // 'fromElement' is in left, 'toElement' is in right  ==> true
        // 'fromElement' is in right, 'toElement' is in left  ==> false
        // 'fromElement' and 'toElement' equal by 'x', and 'fromElement' is in top, 'toElement' is in bottom  ==> true
        // 'fromElement' and 'toElement' equal by 'x', and 'fromElement' is in bottom, 'toElement' is in top  ==> false
        const isLeftRightElements =
            focusedLine.value.fromElementX < focusedLine.value.toElementX
                ? true
                : focusedLine.value.fromElementX > focusedLine.value.toElementX
                    ? false
                    : focusedLine.value.fromElementY <= focusedLine.value.toElementY
                        ? true
                        : false;

        const leftRelationType = isLeftRightElements
            ? focusedLine?.value?.fromRelationType
            : focusedLine?.value?.toRelationType;
        const rightRelationType = isLeftRightElements
            ? focusedLine?.value?.toRelationType
            : focusedLine?.value?.fromRelationType;

        return (
            <div
                className={`menu`}
            // style={{ top: '14px', position: 'absolute', left: '37px' }}
            >
                <div className="controls-group">
                    {DragMenuPart}
                    <div className="control-divider"></div>

                    {/* left line connector */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${leftRelationType && leftRelationType !== 'empty' ? 'selected' : ''}
                                        ${clickedItem == 'left-line-connector' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_line_left_connect', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'line',
                                        });
                                        handleMenuClick('left-line-connector');
                                    }}
                                >
                                    {getLineConnector(leftRelationType, true)}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{getConnectorText(leftRelationType)}</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* swap line connectors */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_line_swap_connectors', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'line',
                                        });
                                        handleMenuClick();
                                        if (leftRelationType && rightRelationType) {
                                            dispatch(setLineConnectorsReversed(focusedLine?.id));
                                        }
                                    }}
                                >
                                    <SwapLinesIconNew />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.line.change_connects')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* right line connector */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${rightRelationType && rightRelationType !== 'empty' ? 'selected' : ''}
                                        ${clickedItem == 'right-line-connector' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_line_right_connect', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'line',
                                        });
                                        handleMenuClick('right-line-connector');
                                    }}
                                >
                                    {getLineConnector(rightRelationType, false)}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{getConnectorText(rightRelationType)}</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>


                    {/* On Update Trigger */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button on-trigger-value ${clickedItem == 'on-update-trigger' ? 'clicked' : ''} ${focusedLine.value.onUpdateTrigger ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_line_on_update', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'line',
                                        });
                                        if (isMoreBtnClicked) {
                                            setIsMoreBtnClicked(false);
                                        }
                                        handleMenuClick('on-update-trigger');
                                    }}
                                >
                                    ON UPDATE
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.line.on_update')}</span>
                                {/* <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + 8
                                </span> */}

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* On Delete Trigger */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button on-trigger-value ${clickedItem == 'on-delete-trigger' ? 'clicked' : ''} ${focusedLine.value.onDeleteTrigger ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_line_on_delete', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'line',
                                        });
                                        if (isMoreBtnClicked) {
                                            setIsMoreBtnClicked(false);
                                        }
                                        handleMenuClick('on-delete-trigger');
                                    }}
                                >
                                    ON DELETE
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.line.on_delete')}</span>
                                {/* <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + 8
                                </span> */}

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>


                    {/* Auto Resize Line */}

                    {/*
                    <div className="control">
                        <button
                            className='control-button'
                            type="button"
                            title="1-auto resize"
                            aria-label="Column Type"
                            aria-pressed="false"
                            onClick={() => {
                                handleMenuClick();
                            }}
                        >
                            RESIZE
                        </button>
                    </div>
                    */}

                    {/* color-picker */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${colorName ? 'selected' : ''}
                                        ${clickedItem == 'color-picker' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_line_color', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'line',
                                        });
                                        handleMenuClick('color-picker');
                                    }}
                                >
                                    <BackgroundColorCircleIcon color={colorName || '#c8d9e0'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.color')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* border */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${['dashes', 'dots'].includes(focusedLine?.value?.solidType) ? 'selected' : ''}
                                        ${clickedItem == 'line-solid-type' ? 'clicked' : ''}
                                    `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_line_border', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'line',
                                        });
                                        handleMenuClick('line-solid-type');
                                    }}
                                >
                                    <LineTypeIcon
                                        isDashes={focusedLine?.value?.solidType === 'dashes'}
                                        isDots={focusedLine?.value?.solidType === 'dots'}
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.border')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* description */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${focusedLine?.value?.description ? 'selected' : ''} ${clickedItem == 'line-description' ? 'clicked' : ''} `}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_line_description', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'line',
                                        });
                                        handleMenuClick('line-description');
                                    }}
                                >
                                    <ElementDescriptionIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.description')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {/* delete */}
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className="control-button"
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_line_delete', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'line',
                                        });
                                        handleMenuClick();
                                        dispatch(deleteLine());
                                        setViewMode(null);
                                    }}
                                >
                                    <DeleteIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.delete')}</span>
                                <span className="tooltip-shortcut">Del</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    {VisibilityMenuPart}
                </div>
            </div>
        );
    };

    // enum menu
    const EnumMenu = () => {
        const [valueString, setValueString] = useState('');

        function parseEnumValues(input) {
            // Обрізаємо зайві пробіли з початку та кінця
            input = input.trim();

            // Якщо рядок огорнутий дужками, спробуємо їх прибрати.
            if ((input.startsWith('(') && input.endsWith(')')) ||
                (input.startsWith('(') && !input.endsWith(')')) ||
                (!input.startsWith('(') && input.endsWith(')'))) {
                // Спробуємо прибрати лише одну пару дужок, якщо вони збалансовані або хоча б початкова або кінцева дужка.
                if (input.startsWith('(')) {
                    input = input.substring(1).trim();
                }
                if (input.endsWith(')')) {
                    input = input.substring(0, input.length - 1).trim();
                }
            }

            const values = [];
            let current = '';
            let insideQuotes = false;
            let quoteChar = null; // може бути '\'' або '\"'

            for (let i = 0; i < input.length; i++) {
                const char = input[i];

                if (insideQuotes) {
                    // Ми знаходимося всередині лапок
                    if (char === quoteChar) {
                        // Зустріли закриваючу лапку
                        insideQuotes = false;
                        quoteChar = null;
                    } else {
                        // Продовжуємо накопичувати символи всередині лапок
                        current += char;
                    }
                } else {
                    // Знаходимося поза лапками
                    if ((char === '"' || char === "'")) {
                        // Починаємо режим лапок
                        insideQuotes = true;
                        quoteChar = char;
                    } else if (char === ',') {
                        // Кома поза лапками - роздільник значень
                        let trimmed = current.trim();
                        if (trimmed.length > 0) {
                            values.push(trimmed);
                        }
                        current = '';
                    } else {
                        // Звичайний символ
                        current += char;
                    }
                }
            }

            // Додаємо останній токен, якщо є
            let trimmed = current.trim();
            if (trimmed.length > 0) {
                values.push(trimmed);
            }

            return values;
        }

        function handleEnumOnChange(e) {
            setValueString(e.target.value);
        }

        function handleEnumOnSubmit() {
            trackEvent('playground_ctx_enum_submit', {
                page: 'playground',
                type: 'context',
                subtype: 'enum',
            });
            const values = parseEnumValues(valueString);

            if (values?.length) {
                // enum
                if (focusedInsideElementRef.current?.elementId && focusedInsideElementRef.current?.insideElementId) {
                    dispatch(setColumnEnum(focusedInsideElementRef.current?.elementId, focusedInsideElementRef.current?.insideElementId, values));
                }
            } else {
                // not enum
                if (focusedInsideElementRef.current?.elementId && focusedInsideElementRef.current?.insideElementId) {
                    dispatch(setColumnEnum(focusedInsideElementRef.current?.elementId, focusedInsideElementRef.current?.insideElementId, null));
                }
            }

            handleSubMenuClick();
            setValueString('');
        }

        useEffect(() => {
            if (focusedInsideElementRef.current?.insideElement?.enumValues) {
                const enumValues = focusedInsideElementRef.current?.insideElement?.enumValues;
                setValueString(enumValues.join(', ') || '');
            }
            return () => { };
        }, []);



        if (!enumBtnRef.current || !menuRef.current) {
            return;
        }

        const contextMenuRect = menuRef.current?.getBoundingClientRect();
        const enumBtnRect = enumBtnRef?.current?.getBoundingClientRect();

        // const top = rect.bottom - contextMenuRect.bottom + contextMenuRect.height;
        const top = 54;
        const left = enumBtnRect.left - contextMenuRect.left - 327 / 2 + 25;

        return (
            <div
                className={`menu`}
                style={{ position: 'absolute', top: `${top}px`, left: `${left}px` }}
            >
                <div className="controls-group">

                    {/* <div className="control"> */}
                    <input
                        maxLength="1000"
                        ref={enumValueMenuInputRef}
                        tabIndex="2"
                        autoFocus={(window.innerWidth >= 1000)}
                        className='enum-input'
                        id="enum-field"
                        type="text"
                        autoComplete="off"
                        spellCheck="false"
                        value={valueString}
                        placeholder={t('t.ctx.tab_col.enum_place')}
                        onChange={(e) => handleEnumOnChange(e)}
                    />
                    {/* </div> */}

                    <div className="control-divider"></div>

                    <div className="control">
                        <button
                            ref={enumValueMenuButtonRef}
                            tabIndex="3"
                            className="control-button enum-click"
                            type="button"
                            // aria-pressed="false"
                            onClick={() => { handleEnumOnSubmit() }}
                        >
                            <OkCheckIcon />
                        </button>
                    </div>

                </div>
            </div>
        );
    };

    // default value menu
    const DefaultValueMenu = () => {
        const [valueString, setValueString] = useState('');

        function handleDefaultValueOnChange(e) {
            setValueString(e.target.value);
        }

        function handleDefaultValueOnSubmit() {
            trackEvent('playground_ctx_default_val_submit', {
                page: 'playground',
                type: 'context',
                subtype: 'default_val',
            });
            if (valueString) {
                // default value
                if (focusedInsideElementRef.current?.elementId && focusedInsideElementRef.current?.insideElementId) {
                    dispatch(setColumnDefaultValue(focusedInsideElementRef.current?.elementId, focusedInsideElementRef.current?.insideElementId, valueString));
                }
            } else {
                // not default value
                if (focusedInsideElementRef.current?.elementId && focusedInsideElementRef.current?.insideElementId) {
                    dispatch(setColumnDefaultValue(focusedInsideElementRef.current?.elementId, focusedInsideElementRef.current?.insideElementId, null));
                }
            }

            handleSubMenuClick();
            setValueString('');
        }

        useEffect(() => {
            if (focusedInsideElementRef.current?.insideElement?.defaultValue) {
                setValueString(focusedInsideElementRef.current?.insideElement?.defaultValue || '');
            }
            return () => { };
        }, []);




        if (!defaultValueBtnRef.current || !menuRef.current) {
            return;
        }

        const contextMenuRect = menuRef.current?.getBoundingClientRect();
        const defaultValueBtnRect = defaultValueBtnRef?.current?.getBoundingClientRect();

        const top = 54;
        const left = defaultValueBtnRect.left - contextMenuRect.left - 327 / 2 + 25;

        return (
            <div
                className={`menu`}
                style={{ position: 'absolute', top: `${top}px`, left: `${left}px` }}
            >
                <div className="controls-group">

                    {/* <div className="control"> */}
                    <input
                        maxLength="1000"
                        ref={defaultValueMenuInputRef}
                        tabIndex="2"
                        autoFocus={(window.innerWidth >= 1000)}
                        className='enum-input'
                        id="default-value-field"
                        type="text"
                        autoComplete="off"
                        spellCheck="false"
                        value={valueString}
                        placeholder={t('t.ctx.tab_col.default_value_place')}
                        onChange={(e) => handleDefaultValueOnChange(e)}
                    />
                    {/* </div> */}

                    <div className="control-divider"></div>

                    <div className="control">
                        <button
                            ref={defaultValueMenuButtonRef}
                            tabIndex="3"
                            className="control-button enum-click"
                            type="button"
                            onClick={() => { handleDefaultValueOnSubmit() }}
                        >
                            <OkCheckIcon />
                        </button>
                    </div>

                </div>
            </div>
        );
    };



    // generated value menu
    const GeneratedValueMenu = () => {
        // const textAreaRef = useRef(null);

        const [valueString, setValueString] = useState('');

        function handleGeneratedValueOnChange(e) {
            setValueString(e.target.value);
        }

        function handleGeneratedValueOnSubmit() {
            trackEvent('playground_ctx_generated_val_submit', {
                page: 'playground',
                type: 'context',
                subtype: 'generated_val',
            });
            if (valueString) {
                // generated value
                if (focusedInsideElementRef.current?.elementId && focusedInsideElementRef.current?.insideElementId) {
                    dispatch(setColumnGeneratedValue(focusedInsideElementRef.current?.elementId, focusedInsideElementRef.current?.insideElementId, valueString));
                }
            } else {
                // not generated value
                if (focusedInsideElementRef.current?.elementId && focusedInsideElementRef.current?.insideElementId) {
                    dispatch(setColumnGeneratedValue(focusedInsideElementRef.current?.elementId, focusedInsideElementRef.current?.insideElementId, null));
                }
            }

            handleSubMenuClick();
            setValueString('');
        }



        // Функція для автоматичного коригування висоти
        const adjustHeight = () => {
            if (generatedValueMenuInputRef.current) {
                // Скидаємо висоту перед тим, як визначити нову
                generatedValueMenuInputRef.current.style.height = 'auto';
                // Встановлюємо висоту на основі контенту, але не більше максимального розміру
                generatedValueMenuInputRef.current.style.height = `${generatedValueMenuInputRef.current.scrollHeight}px`;
            }
        };
        useEffect(() => {
            adjustHeight();
        }, [valueString]);


        useEffect(() => {
            if (focusedInsideElementRef.current?.insideElement?.generatedValue) {
                setValueString(focusedInsideElementRef.current?.insideElement?.generatedValue || '');
            }
            return () => { };
        }, []);


        if (!generatedValueBtnRef.current || !menuRef.current) {
            return;
        }

        const contextMenuRect = menuRef.current?.getBoundingClientRect();
        const generatedValueBtnRect = generatedValueBtnRef?.current?.getBoundingClientRect();

        const top = 54;
        const left = generatedValueBtnRect.left - contextMenuRect.left - 327 / 2 + 25;

        return (
            <div
                className={`menu`}
                style={{ position: 'absolute', top: `${top}px`, left: `${left}px` }}
            >
                <div className="controls-group">

                    <textarea
                        maxLength="1000"
                        ref={generatedValueMenuInputRef}
                        // ref={textAreaRef}
                        tabIndex="2"
                        autoFocus={(window.innerWidth >= 1000)}
                        id="generated-field"
                        className='generated-textarea'
                        type="text"
                        autoComplete="off"
                        spellCheck="false"
                        value={valueString}
                        placeholder={t('t.ctx.tab_col.generated_value_place')}
                        onChange={(e) => handleGeneratedValueOnChange(e)}
                    />

                    <div className="control-divider"></div>

                    <div className="control">
                        <button
                            ref={generatedValueMenuButtonRef}
                            tabIndex="3"
                            className="control-button enum-click"
                            type="button"
                            onClick={() => { handleGeneratedValueOnSubmit() }}
                        >
                            <OkCheckIcon />
                        </button>
                    </div>

                </div>
            </div>
        );
    };

    // check value menu
    const CheckValueMenu = () => {
        // const textAreaRef = useRef(null);

        const [valueString, setValueString] = useState('');

        function handleCheckValueOnChange(e) {
            setValueString(e.target.value);
        }

        function handleCheckValueOnSubmit() {
            trackEvent('playground_ctx_check_submit', {
                page: 'playground',
                type: 'context',
                subtype: 'check',
            });
            if (valueString) {
                // check value
                if (focusedInsideElementRef.current?.elementId && focusedInsideElementRef.current?.insideElementId) {
                    dispatch(setColumnCheckValue(focusedInsideElementRef.current?.elementId, focusedInsideElementRef.current?.insideElementId, valueString));
                }
            } else {
                // not check value
                if (focusedInsideElementRef.current?.elementId && focusedInsideElementRef.current?.insideElementId) {
                    dispatch(setColumnCheckValue(focusedInsideElementRef.current?.elementId, focusedInsideElementRef.current?.insideElementId, null));
                }
            }

            handleSubMenuClick();
            setValueString('');
        }



        // Функція для автоматичного коригування висоти
        const adjustHeight = () => {
            if (checkValueMenuInputRef.current) {
                // Скидаємо висоту перед тим, як визначити нову
                checkValueMenuInputRef.current.style.height = 'auto';
                // Встановлюємо висоту на основі контенту, але не більше максимального розміру
                checkValueMenuInputRef.current.style.height = `${checkValueMenuInputRef.current.scrollHeight}px`;
            }
        };
        useEffect(() => {
            adjustHeight();
        }, [valueString]);


        useEffect(() => {
            if (focusedInsideElementRef.current?.insideElement?.checkValue) {
                setValueString(focusedInsideElementRef.current?.insideElement?.checkValue || '');
            }
            return () => { };
        }, []);


        if (!checkValueBtnRef.current || !menuRef.current) {
            return;
        }

        const contextMenuRect = menuRef.current?.getBoundingClientRect();
        const checkValueBtnRect = checkValueBtnRef?.current?.getBoundingClientRect();

        const top = 54;
        const left = checkValueBtnRect.left - contextMenuRect.left - 327 / 2 + 25;

        return (
            <div
                className={`menu`}
                style={{ position: 'absolute', top: `${top}px`, left: `${left}px` }}
            >
                <div className="controls-group">

                    <textarea
                        maxLength="1000"
                        ref={checkValueMenuInputRef}
                        // ref={textAreaRef}
                        tabIndex="2"
                        autoFocus={(window.innerWidth >= 1000)}
                        id="check-field"
                        className='generated-textarea'
                        type="text"
                        autoComplete="off"
                        spellCheck="false"
                        value={valueString}
                        placeholder={t('t.ctx.tab_col.check_place')}
                        onChange={(e) => handleCheckValueOnChange(e)}
                    />

                    <div className="control-divider"></div>

                    <div className="control">
                        <button
                            ref={checkValueMenuButtonRef}
                            tabIndex="3"
                            className="control-button enum-click"
                            type="button"
                            onClick={() => { handleCheckValueOnSubmit() }}
                        >
                            <OkCheckIcon />
                        </button>
                    </div>

                </div>
            </div>
        );
    };


    // description menu
    const DescriptionMenu = (props) => {
        // const textAreaRef = useRef(null);

        const [valueString, setValueString] = useState('');

        let positionTop = 0;
        let positionLeft = 0;

        switch (props.type) {
            case 'note': {
                positionTop = 54;
                positionLeft = 303;
                break;
            }
            case 'pen': {
                positionTop = 54;
                // positionLeft = 20;
                positionLeft = 6;
                break;
            }
            case 'table': {
                positionTop = 54;
                // positionLeft = 120;
                positionLeft = 5 - 30;
                break;
            }
            case 'column': {
                positionTop = 54;
                positionLeft = 362;
                break;
            }
            case 'area': {
                positionTop = 54;
                positionLeft = 119 - 40;
                break;
            }
            case 'line': {
                positionTop = 54;
                positionLeft = 330 - 30;
                break;
            }
            default:
                break;
        }

        function handleDescriptionOnChange(e) {
            setValueString(e.target.value);
        }

        function handleDescriptionOnSubmit() {
            trackEvent(`playground_ctx_${props.type}_descript_sbmt`, {
                page: 'playground',
                type: 'context',
                subtype: 'description',
            });
            const value = valueString || null;

            switch (props.type) {
                case 'pen':
                case 'note':
                case 'table': {
                    const keys = Object.keys(focusedElements);
                    if (!keys.length) {
                        return;
                    }
                    const element = focusedElements[keys[0]];
                    dispatch(setElementDescription(element.id, value));
                    break;
                }
                case 'column': {
                    const column = focusedInsideElementRef.current;
                    if (column?.elementId && column?.insideElementId) {
                        dispatch(setColumnDescription(column?.elementId, column?.insideElementId, value));
                    }
                    break;
                }
                case 'area': {
                    if (!focusedArea) {
                        return;
                    }
                    dispatch(setAreaDescription(focusedArea.id, value));
                    break;
                }
                case 'line': {
                    if (!focusedLine) {
                        return;
                    }
                    dispatch(setLineDescription(focusedLine.id, value));
                    break;
                }
                default:
                    break;
            }

            handleSubMenuClick();
            setValueString('');
        }

        useEffect(() => {
            let descriptionValue = '';

            switch (props.type) {
                case 'note':
                case 'pen':
                case 'table': {
                    const keys = Object.keys(focusedElements);
                    if (!keys.length) {
                        return;
                    }
                    const element = focusedElements[keys[0]];
                    descriptionValue = element?.value?.description || '';
                    break;
                }
                case 'column': {
                    const column = focusedInsideElementRef.current;
                    descriptionValue = column?.insideElement?.description || '';
                    break;
                }
                case 'area': {
                    if (!focusedArea) {
                        return;
                    }
                    descriptionValue = focusedArea?.value?.description || '';
                    break;
                }
                case 'line': {
                    if (!focusedLine) {
                        return;
                    }
                    descriptionValue = focusedLine?.value?.description || '';
                    break;
                }
                default:
                    break;
            }

            if (descriptionValue) {
                setValueString(descriptionValue);
            }

            return () => { };
        }, []);


        // Функція для автоматичного коригування висоти
        const adjustHeight = () => {
            if (descriptionMenuInputRef.current) {
                // Скидаємо висоту перед тим, як визначити нову
                descriptionMenuInputRef.current.style.height = 'auto';
                // Встановлюємо висоту на основі контенту, але не більше максимального розміру
                descriptionMenuInputRef.current.style.height = `${descriptionMenuInputRef.current.scrollHeight}px`;
            }
        };
        useEffect(() => {
            adjustHeight();
        }, [valueString]);




        if (props.type == 'column') {
            if (!columnDescriptionBtnRef.current || !menuRef.current) {
                return;
            }

            const contextMenuRect = menuRef.current?.getBoundingClientRect();
            const columnDescriptionBtnRect = columnDescriptionBtnRef?.current?.getBoundingClientRect();

            positionTop = 54;
            positionLeft = columnDescriptionBtnRect.left - contextMenuRect.left - 324 / 2 + 25 - 30;
        }

        return (
            <div
                className={`menu`}
                // style={{ position: 'absolute', top: `${top}px`, left: `${left}px` }}
                style={{ position: 'absolute', top: `${positionTop}px`, left: `${positionLeft}px` }}
            >
                <div className="controls-group">

                    {/* <div className="control"> */}
                    <textarea
                        maxLength="1000"
                        ref={descriptionMenuInputRef}
                        // ref={textAreaRef}
                        tabIndex="2"
                        autoFocus={(window.innerWidth >= 1000)}
                        id="description-field"
                        className='description-textarea'
                        type="text"
                        autoComplete="off"
                        spellCheck="false"
                        value={valueString}
                        // placeholder={`${props.type === 'pen' ? 'pen-segment' : props.type} description`}
                        // placeholder={t('t.ctx.base.description_place', { type: props.type === 'pen' ? 'pen-segment' : props.type })}
                        placeholder={t(`t.ctx.base.description_${props.type}_place`)}
                        onChange={(e) => handleDescriptionOnChange(e)}
                    />
                    {/* </div> */}

                    <div className="control-divider"></div>

                    <div className="control">
                        <button
                            ref={descriptionMenuButtonRef}
                            tabIndex="3"
                            className="control-button enum-click"
                            type="button"
                            onClick={() => { handleDescriptionOnSubmit() }}
                        >
                            <OkCheckIcon />
                        </button>
                    </div>

                </div>
            </div>
        );
    };

    // key menu
    const getKeyMenu = () => {
        if (!focusedInsideElementRef.current) {
            return;
        }

        const column = focusedInsideElementRef.current;

        if (!column?.elementId || !column?.insideElementId) {
            return;
        }

        const isPK = column?.insideElement?.isPK;
        const isFK = column?.insideElement?.isFK;

        return (
            <div
                className={`menu key-menu`}
                style={{ top: '54px', position: 'absolute', left: `${133 - 53}px` }}
            >
                <div className="controls-group">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_key_empty', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'keys',
                                        });
                                        handleSubMenuClick();
                                        if (isPK || isFK) {
                                            dispatch(setColumnKey(column?.elementId, column?.insideElementId, null));
                                        }
                                    }}
                                    style={{ fontSize: '24px', fontWeight: 700 }}
                                >
                                    <CircleNoneIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.keys.none')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${isPK ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_key_pk', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'keys',
                                        });
                                        handleSubMenuClick();
                                        if (!isPK) {
                                            dispatch(setColumnKey(column?.elementId, column?.insideElementId, 'pk'));
                                        }
                                    }}
                                >
                                    <KeyIcon isPK={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.keys.pk')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${isFK ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_key_fk', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'keys',
                                        });
                                        handleSubMenuClick();
                                        if (!isFK) {
                                            dispatch(setColumnKey(column?.elementId, column?.insideElementId, 'fk'));
                                        }
                                    }}
                                >
                                    <KeyIcon isFK={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.keys.fk')}</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div >
        )
    };
    // index menu
    const getIndexMenu = () => {
        if (!focusedInsideElementRef.current) {
            return;
        }

        const column = focusedInsideElementRef.current;

        if (!column?.elementId || !column?.insideElementId) {
            return;
        }

        const indexType = column?.insideElement?.index?.type;

        return (
            <div
                className={`menu index-menu`}
                style={{ top: '54px', position: 'absolute', left: `${172 - 99 + 26}px` }}
            >
                <div className="controls-group">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        handleSubMenuClick();
                                        if (indexType) {
                                            dispatch(setColumnIndex(column?.elementId, column?.insideElementId, null));
                                        }
                                    }}
                                    style={{ fontSize: '24px', fontWeight: 700 }}
                                >
                                    <CircleNoneIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.indexes.none')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${indexType === 'regular' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_index_regular', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'indexes',
                                        });
                                        handleSubMenuClick();
                                        if (indexType !== 'regular') {
                                            dispatch(setColumnIndex(column?.elementId, column?.insideElementId, 'regular'));
                                        }
                                    }}
                                >
                                    <svg
                                        className={`context-menu-column-index menu-item regular ${indexType === 'regular' ? 'selected' : ''}`}
                                    >
                                        <polygon
                                            points={`${rombRadius + 1},1 ${rombRadius * 2 + 1},${rombRadius + 1} ${rombRadius + 1},${rombRadius * 2 + 1} 1,${rombRadius + 1}`}
                                        />
                                    </svg>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.indexes.regular')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${indexType === 'unique' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_index_unique', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'indexes',
                                        });
                                        handleSubMenuClick();
                                        if (indexType !== 'unique') {
                                            dispatch(setColumnIndex(column?.elementId, column?.insideElementId, 'unique'));
                                        }
                                    }}
                                >
                                    <svg
                                        className={`context-menu-column-index menu-item unique`}
                                    >
                                        <polygon
                                            points={`${rombRadius + 1},1 ${rombRadius * 2 + 1},${rombRadius + 1} ${rombRadius + 1},${rombRadius * 2 + 1} 1,${rombRadius + 1}`}
                                        />
                                    </svg>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.indexes.unique')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    { /* Composite index*/}
                    {/* <Tooltip.Root delayDuration={600} disableHoverableContent>
                    <Tooltip.Trigger asChild>
                        <div className="control">
                            <button
                                className={`control-button ${indexType === 'composite' ? 'selected' : '' }`}
                                type="button"
                                aria-pressed="false"
                                onClick={() => {
                                    handleSubMenuClick();
                                    if (indexType !== 'composite') {
                                        dispatch(setColumnIndex(column?.elementId, column?.insideElementId, 'composite'));
                                    }
                                }}
                            >
                                <svg
                                    className={`context-menu-column-index composite`}
                                >
                                    <polygon
                                        points={`${rombRadius + 1},1 ${rombRadius * 2 + 1 },${rombRadius + 1} ${rombRadius + 1},${rombRadius * 2 + 1 } 1,${rombRadius + 1}`}
                                    />
                                </svg>
                            </button>
                        </div>
                    </Tooltip.Trigger>
                    <Tooltip.Portal>
                        <Tooltip.Content
                            className="tooltip-content tooltip-controls"
                            side="bottom"
                            align="center"
                            sideOffset={10}
                        >
                            <span>Composite</span>

                            <Tooltip.Arrow className="tooltip-arrow" />
                        </Tooltip.Content>
                    </Tooltip.Portal>
                </Tooltip.Root> */}

                    {/* <div className="control-divider"></div> */}

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${indexType === 'fullText' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_index_text', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'indexes',
                                        });
                                        handleSubMenuClick();
                                        if (indexType !== 'fullText') {
                                            dispatch(setColumnIndex(column?.elementId, column?.insideElementId, 'fullText'));
                                        }
                                    }}
                                >
                                    <svg
                                        className={`context-menu-column-index menu-item fullText`}
                                    >
                                        <polygon
                                            points={`${rombRadius + 1},1 ${rombRadius * 2 + 1},${rombRadius + 1} ${rombRadius + 1},${rombRadius * 2 + 1} 1,${rombRadius + 1}`}
                                        />
                                    </svg>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.tab_col.indexes.full_text')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        )
    };

    // left line connector menu
    const getleftLineConnectorMenu = (focusedLine) => {
        if (!focusedLine) {
            return;
        }

        // 'fromElement' is in left, 'toElement' is in right  ==> true
        // 'fromElement' is in right, 'toElement' is in left  ==> false
        // 'fromElement' and 'toElement' equal by 'x', and 'fromElement' is in top, 'toElement' is in bottom  ==> true
        // 'fromElement' and 'toElement' equal by 'x', and 'fromElement' is in bottom, 'toElement' is in top  ==> false
        const isLeftRightElements =
            focusedLine.value.fromElementX < focusedLine.value.toElementX
                ? true
                : focusedLine.value.fromElementX > focusedLine.value.toElementX
                    ? false
                    : focusedLine.value.fromElementY <= focusedLine.value.toElementY
                        ? true
                        : false;

        const leftRelationType = isLeftRightElements
            ? focusedLine?.value?.fromRelationType
            : focusedLine?.value?.toRelationType;
        const direction = isLeftRightElements ? 'from' : 'to';

        return (
            <div
                className={`menu`}
                // style={{ top: '68px', position: 'absolute', left: '71px' }}
                style={{ top: '54px', position: 'absolute', left: '32px' }}
            >
                <div className="controls-group vertical">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${leftRelationType === 'empty' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_left_connector_empty', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'left_connector',
                                        });
                                        handleSubMenuClick();
                                        if (leftRelationType !== 'empty') {
                                            dispatch(setLineConnector(focusedLine?.id, direction, 'empty'));
                                        }
                                    }}
                                >
                                    <LineConnectorEmptyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.line.connects.empty')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${leftRelationType === 'one' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_left_connector_one', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'left_connector',
                                        });
                                        handleSubMenuClick();
                                        if (leftRelationType !== 'one') {
                                            dispatch(setLineConnector(focusedLine?.id, direction, 'one'));
                                        }
                                    }}
                                >
                                    <LineConnectorOneIcon isLeft={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.line.connects.one_to')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${leftRelationType === 'many' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_left_connector_many', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'left_connector',
                                        });
                                        handleSubMenuClick();

                                        if (leftRelationType !== 'many') {
                                            dispatch(
                                                setLineConnector(
                                                    focusedLine?.id,
                                                    direction,
                                                    'many'
                                                )
                                            );
                                        }
                                    }}
                                >
                                    <LineConnectorManyIcon isLeft={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.line.connects.many_to')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${leftRelationType === 'one-null' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_left_connector_one_null', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'left_connector',
                                        });
                                        handleSubMenuClick();
                                        if (leftRelationType !== 'one-null') {
                                            dispatch(setLineConnector(focusedLine?.id, direction, 'one-null'));
                                        }
                                    }}
                                >
                                    <LineConnectorOneNullIcon isLeft={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.line.connects.one_null_to')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${leftRelationType === 'many-null' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_left_connector_many_null', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'left_connector',
                                        });
                                        handleSubMenuClick();
                                        if (leftRelationType !== 'many-null') {
                                            dispatch(setLineConnector(focusedLine?.id, direction, 'many-null'));
                                        }
                                    }}
                                >
                                    <LineConnectorManyNullIcon isLeft={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.line.connects.many_null_to')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        );
    };

    // right line connector menu
    const getRightLineConnectorMenu = (focusedLine) => {
        if (!focusedLine) {
            return;
        }

        // 'fromElement' is in left, 'toElement' is in right  ==> true
        // 'fromElement' is in right, 'toElement' is in left  ==> false
        // 'fromElement' and 'toElement' equal by 'x', and 'fromElement' is in top, 'toElement' is in bottom  ==> true
        // 'fromElement' and 'toElement' equal by 'x', and 'fromElement' is in bottom, 'toElement' is in top  ==> false
        const isLeftRightElements =
            focusedLine.value.fromElementX < focusedLine.value.toElementX
                ? true
                : focusedLine.value.fromElementX > focusedLine.value.toElementX
                    ? false
                    : focusedLine.value.fromElementY <= focusedLine.value.toElementY
                        ? true
                        : false;

        const rightRelationType = isLeftRightElements
            ? focusedLine?.value?.toRelationType
            : focusedLine?.value?.fromRelationType;
        const direction = isLeftRightElements ? 'to' : 'from';

        return (
            <div
                className={`menu`}
                // style={{ top: '68px', position: 'absolute', left: `${174}px` }}
                style={{ top: '54px', position: 'absolute', left: `${135}px` }}
            >
                <div className="controls-group vertical">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${rightRelationType === 'empty' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_right_connector_empty', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'right_connector',
                                        });
                                        handleSubMenuClick();
                                        if (rightRelationType !== 'empty') {
                                            dispatch(setLineConnector(focusedLine?.id, direction, 'empty'));
                                        }
                                    }}
                                >
                                    <LineConnectorEmptyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Empty</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${rightRelationType === 'one' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_right_connector_one', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'right_connector',
                                        });
                                        handleSubMenuClick();
                                        if (rightRelationType !== 'one') {
                                            dispatch(setLineConnector(focusedLine?.id, direction, 'one'));
                                        }
                                    }}
                                >
                                    <LineConnectorOneIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>One To</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${rightRelationType === 'many' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_right_connector_many', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'right_connector',
                                        });
                                        handleSubMenuClick();
                                        if (rightRelationType !== 'many') {
                                            dispatch(setLineConnector(focusedLine?.id, direction, 'many'));
                                        }
                                    }}
                                >
                                    <LineConnectorManyIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Many To</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${rightRelationType === 'one-null' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_right_connector_one_null', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'right_connector',
                                        });
                                        handleSubMenuClick();
                                        if (rightRelationType !== 'one-null') {
                                            dispatch(setLineConnector(focusedLine?.id, direction, 'one-null'));
                                        }
                                    }}
                                >
                                    <LineConnectorOneNullIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>One / Null To</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${rightRelationType === 'many-null' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_right_connector_many_null', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'right_connector',
                                        });
                                        handleSubMenuClick();
                                        if (rightRelationType !== 'many-null') {
                                            dispatch(setLineConnector(focusedLine?.id, direction, 'many-null')
                                            );
                                        }
                                    }}
                                >
                                    <LineConnectorManyNullIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Many / Null To</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        );
    };

    // line type menu
    const getLineSolidTypeMenu = (focusedLine) => {
        if (!focusedLine) {
            return;
        }

        return (
            <div
                className={`menu`}
                // style={{ top: '68px', position: 'absolute', left: `${236}px` }}
                style={{ top: '54px', position: 'absolute', left: `${442}px` }}
            >
                <div className="controls-group vertical">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${(!focusedLine?.value?.solidType || focusedLine?.value?.solidType === 'solid') ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_solid_type_solid', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'solid_types',
                                        });
                                        handleSubMenuClick();
                                        dispatch(setLineSolidType(focusedLine?.id, 'solid'));
                                    }}
                                >
                                    <LineTypeIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.borders.solid')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${focusedLine?.value?.solidType === 'dashes' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_solid_type_dashed', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'solid_types',
                                        });
                                        handleSubMenuClick();
                                        dispatch(setLineSolidType(focusedLine?.id, 'dashes')
                                        );
                                    }}
                                >
                                    <LineTypeIcon isDashes={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.borders.dashed')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector ${focusedLine?.value?.solidType === 'dots' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_solid_type_dots', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'solid_types',
                                        });
                                        handleSubMenuClick();
                                        dispatch(setLineSolidType(focusedLine?.id, 'dots')
                                        );
                                    }}
                                >
                                    <LineTypeIcon isDots={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.borders.dotted')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        );
    };

    // element border menu
    const getElementBorderMenu = (focusedElements, focusedArea) => {
        const areaCount = focusedArea ? 1 : 0;
        const elementsCount = Object.keys(focusedElements).length;
        let itemsCount = 0;

        if (!elementsCount && !focusedArea) {
            return;
        }

        let borderCounter = { none: 0, solid: 0, dashes: 0, dots: 0 };
        let positionTop = 0;
        let positionLeft = 0;

        // 1. elements are focused
        if (elementsCount) {
            itemsCount = elementsCount;

            // 1.1 elements border
            for (let key in focusedElements) {
                const element = focusedElements[key];

                if (!element?.value?.border) {
                    borderCounter.none++;
                } else {
                    borderCounter[element?.value?.border]++;
                }
            }

            // 1.2. elements menu position
            if (elementsCount > 1) {
                positionTop = 54;
                // positionLeft = 188;
                positionLeft = 229;
            } else {
                const elementKey = Object.keys(focusedElements)[0];
                const element = focusedElements[elementKey];

                if (element.type === 'table') {
                    positionTop = 54;
                    positionLeft = 79;
                } else if (element.type === 'note') {
                    positionTop = 54;
                    positionLeft = 375;
                }
            }

            // 2. area is focused
        } else {
            itemsCount = areaCount;

            // 2.1. area border
            if (!focusedArea?.value?.border) {
                borderCounter.solid++;
            } else {
                borderCounter[focusedArea?.value?.border]++;
            }

            // 2.2. area position
            positionTop = 54;
            positionLeft = 187;
        }

        return (
            <div
                className={`menu`}
                style={{
                    top: `${positionTop}px`,
                    position: 'absolute',
                    left: `${positionLeft}px`,
                }}
            >
                <div className="controls-group vertical">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector border`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_border_empty', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'borders',
                                        });
                                        handleSubMenuClick();

                                        if (elementsCount) {
                                            dispatch(setElementsBorder(null));
                                        } else {
                                            dispatch(setAreaBorder(null));
                                        }
                                    }}
                                >
                                    <CircleNoneIcon isBorder={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.borders.none')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector border ${borderCounter.solid == itemsCount ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_border_solid', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'borders',
                                        });
                                        handleSubMenuClick();
                                        if (elementsCount) {
                                            dispatch(setElementsBorder('solid'));
                                        } else {
                                            dispatch(setAreaBorder('solid'));
                                        }
                                    }}
                                >
                                    <ElementBorderIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.borders.solid')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector border ${borderCounter.dashes == itemsCount ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_border_dashed', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'borders',
                                        });
                                        handleSubMenuClick();
                                        if (elementsCount) {
                                            dispatch(setElementsBorder('dashes'));
                                        } else {
                                            dispatch(setAreaBorder('dashes'));
                                        }
                                    }}
                                >
                                    <ElementBorderIcon isDashes={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.borders.dashed')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button line-connector border ${borderCounter.dots == itemsCount ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_border_dots', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'borders',
                                        });
                                        handleSubMenuClick();
                                        if (elementsCount) {
                                            dispatch(setElementsBorder('dots'));
                                        } else {
                                            dispatch(setAreaBorder('dots'));
                                        }
                                    }}
                                >
                                    <ElementBorderIcon isDots={true} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.borders.dotted')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        );
    };

    // color picker menu
    const getColorPickerMenu = (focusedElements, focusedLine, focusedArea) => {
        const elementsCount = Object.keys(focusedElements).length;
        if (!elementsCount && !focusedLine && !focusedArea) {
            return;
        }

        let colorCounter = {
            none: 0,
            blue: 0,
            green: 0,
            red: 0,
            purple: 0,
            violet: 0,
        };

        let isElementsFocused = false;

        if (elementsCount) {
            isElementsFocused = true;
            for (let key in focusedElements) {
                const element = focusedElements[key];

                if (!element?.value?.color) {
                    colorCounter.none++;
                } else {
                    colorCounter[element?.value?.color]++;
                }
            }
        } else if (focusedLine) {
            if (!focusedLine?.value?.color) {
                colorCounter.none++;
            } else {
                colorCounter[focusedLine?.value?.color]++;
            }
        } else {
            if (!focusedArea?.value?.color) {
                colorCounter.none++;
            } else {
                colorCounter[focusedArea?.value?.color]++;
            }
        }

        const itemsCount = isElementsFocused ? elementsCount : 1;

        let positionTop = 0;
        let positionLeft = 0;

        if (isElementsFocused && elementsCount > 1) {
            positionTop = 54;
            // positionLeft = 193;
            positionLeft = 148;
        } else if (isElementsFocused && elementsCount == 1) {
            const elementKey = Object.keys(focusedElements)[0];
            const element = focusedElements[elementKey];

            if (element.type === 'table') {
                positionTop = 54;
                positionLeft = -9;
            } else if (element.type === 'note') {
                positionTop = 54;
                positionLeft = 283;
            }
        } else if (focusedLine) {
            positionTop = 54;
            // positionLeft = 245;
            positionLeft = 354;
        } else {
            positionTop = 54;
            // positionLeft = 193;
            positionLeft = 87;
        }

        return (
            <div
                className={`menu`}
                style={{
                    top: `${positionTop}px`,
                    position: 'absolute',
                    left: `${positionLeft}px`,
                }}
            >
                <div className="controls-group color-picker">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${colorCounter.none == itemsCount ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_color_default', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'colors',
                                        });
                                        handleSubMenuClick();
                                        if (isElementsFocused) {
                                            dispatch(setElementsColor(null));
                                        } else if (focusedLine) {
                                            dispatch(setLineColor(focusedLine?.id, null));
                                        } else {
                                            dispatch(setAreaColor(null));
                                        }
                                    }}
                                >
                                    <BackgroundColorCircleIcon
                                        isItem={true}
                                        color={
                                            isElementsFocused
                                                ? 'grey'
                                                : focusedLine
                                                    ? '#c8d9e0'
                                                    : 'grey'
                                        }
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.colors.default')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${colorCounter.blue == itemsCount ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_color_blue', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'colors',
                                        });
                                        handleSubMenuClick();
                                        if (isElementsFocused) {
                                            dispatch(setElementsColor('blue'));
                                        } else if (focusedLine) {
                                            dispatch(setLineColor(focusedLine?.id, 'blue'));
                                        } else {
                                            dispatch(setAreaColor('blue'));
                                        }
                                    }}
                                >
                                    <BackgroundColorCircleIcon
                                        isItem={true}
                                        color={'blue'}
                                    />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.colors.blue')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${colorCounter.green == itemsCount ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_color_green', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'colors',
                                        });
                                        handleSubMenuClick();
                                        if (isElementsFocused) {
                                            dispatch(setElementsColor('green'));
                                        } else if (focusedLine) {
                                            dispatch(setLineColor(focusedLine?.id, 'green'));
                                        } else {
                                            dispatch(setAreaColor('green'));
                                        }
                                    }}
                                >
                                    <BackgroundColorCircleIcon isItem={true} color={'green'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.colors.green')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${colorCounter.red == itemsCount ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_color_red', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'colors',
                                        });
                                        handleSubMenuClick();
                                        if (isElementsFocused) {
                                            dispatch(setElementsColor('red'));
                                        } else if (focusedLine) {
                                            dispatch(setLineColor(focusedLine?.id, 'red'));
                                        } else {
                                            dispatch(setAreaColor('red'));
                                        }
                                    }}
                                >
                                    <BackgroundColorCircleIcon isItem={true} color={'red'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.colors.red')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${colorCounter.purple == itemsCount ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_color_purple', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'colors',
                                        });
                                        handleSubMenuClick();
                                        if (isElementsFocused) {
                                            dispatch(setElementsColor('purple'));
                                        } else if (focusedLine) {
                                            dispatch(setLineColor(focusedLine?.id, 'purple'));
                                        } else {
                                            dispatch(setAreaColor('purple'));
                                        }
                                    }}
                                >
                                    <BackgroundColorCircleIcon isItem={true} color={'purple'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.colors.purple')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${colorCounter.violet == itemsCount ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_color_violet', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'colors',
                                        });
                                        handleSubMenuClick();
                                        if (isElementsFocused) {
                                            dispatch(setElementsColor('violet'));
                                        } else if (focusedLine) {
                                            dispatch(setLineColor(focusedLine?.id, 'violet'));
                                        } else {
                                            dispatch(setAreaColor('violet'));
                                        }
                                    }}
                                >
                                    <BackgroundColorCircleIcon isItem={true} color={'violet'} />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="top"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctx.base.colors.violet')}</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        );
    };

    // delete element menu
    const getDeleteElementMenu = (focusedElements, focusedGroupElements, focusedGroupAreas) => {
        const elementsCount = Object.keys(focusedElements).length;
        const groupElementsCount = Object.keys(focusedGroupElements).length;
        const groupAreasCount = Object.keys(focusedGroupAreas).length;
        if (!elementsCount && !groupElementsCount && !groupAreasCount) {
            return;
        }

        let positionLeft = 0;

        if (elementsCount > 1) {
            positionLeft = 305;
        } else if (groupElementsCount || groupAreasCount) {
            positionLeft = 155;
        } else {
            // positionLeft = 309;
            positionLeft = 209;
        }

        return (
            <div
                className={`menu`}
                style={{
                    top: '54px',
                    position: 'absolute',
                    left: `${positionLeft}px`,
                }}
            >
                <div className="controls-group">

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_delete_elements_yes', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'delete_elements',
                                        });
                                        handleSubMenuClick();

                                        if (groupElementsCount || groupAreasCount) {
                                            dispatch(deleteFocusedGroup());
                                        } else {
                                            dispatch(deleteElements({}));
                                        }
                                        setViewMode(null);
                                    }}
                                >
                                    <MarkYesIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.yes')}</span>
                                <span className="tooltip-shortcut">Enter</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_delete_elements_no', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'delete_elements',
                                        });
                                        handleSubMenuClick();
                                    }}
                                >
                                    <MarkNoIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.no')}</span>
                                <span className="tooltip-shortcut">Esc</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>



                </div>
            </div>
        );
    };

    // note alignment menu
    const getNoteAlignmentMenu = (focusedElements) => {
        const keys = Object.keys(focusedElements);
        if (!keys?.length) {
            return;
        }
        const element = focusedElements[keys[0]];

        return (
            <div
                className={`menu alignment-menu`}
                style={{ top: '54px', position: 'absolute', left: '133px' }}
            >
                <div className="controls-group">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${(!element.value.alignmentHorizontal || element.value.alignmentHorizontal === 'left') ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_align_left', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_align',
                                        });
                                        handleSubMenuClick();

                                        if (element) {
                                            dispatch(setNoteAlignment(element.id, 'left'));
                                        }
                                    }}
                                >
                                    <AlignLeftIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Left</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${element.value.alignmentHorizontal === 'center' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_align_hor_center', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_align',
                                        });
                                        handleSubMenuClick();
                                        if (element) {
                                            dispatch(setNoteAlignment(element.id, 'horizontalCenter'));
                                        }
                                    }}
                                >
                                    <AlignCenterIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Center</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${element.value.alignmentHorizontal === 'right' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_align_right', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_align',
                                        });
                                        handleSubMenuClick();
                                        if (element) {
                                            dispatch(setNoteAlignment(element.id, 'right'));
                                        }
                                    }}
                                >
                                    <AlignRightIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Right</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>

                <div className="control-divider"></div>

                <div className="controls-group">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${(!element.value.alignmentVertical || element.value.alignmentVertical === 'top') ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_align_top', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_align',
                                        });
                                        handleSubMenuClick();
                                        if (element) {
                                            dispatch(setNoteAlignment(element.id, 'top'));
                                        }
                                    }}
                                >
                                    <AlignTopIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Top</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${element.value.alignmentVertical === 'center' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_align_ver_center', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_align',
                                        });
                                        handleSubMenuClick();
                                        if (element) {
                                            dispatch(setNoteAlignment(element.id, 'verticalCenter'));
                                        }
                                    }}
                                >
                                    <AlignVerticalCenterIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Center</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${element.value.alignmentVertical === 'bottom' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_align_bottom', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_align',
                                        });
                                        handleSubMenuClick();
                                        if (element) {
                                            dispatch(setNoteAlignment(element.id, 'bottom'));
                                        }
                                    }}
                                >
                                    <AlignBottomIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Bottom</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        );
    };

    // note font styles menu
    const getNoteFontStylesMenu = (focusedElements) => {
        const keys = Object.keys(focusedElements);
        if (!keys?.length) {
            return;
        }
        const element = focusedElements[keys[0]];

        return (
            <div
                className={`menu font-styles-menu`}
                style={{ top: '54px', position: 'absolute', left: '18px' }}
            >
                <div className="controls-group">
                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_font_style_bold', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_font_styles',
                                        });
                                        handleSubMenuClick();
                                        dispatch(setNoteFontStyle(element.id, 'bold', 'value')
                                        );
                                    }}
                                >
                                    <BoldTextIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Bold</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_font_style_italic', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_font_styles',
                                        });
                                        handleSubMenuClick();
                                        dispatch(setNoteFontStyle(element.id, 'italic', 'value'));
                                    }}
                                >
                                    <ItalicTextIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Italic</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_font_style_underline', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_font_styles',
                                        });
                                        handleSubMenuClick();
                                        dispatch(setNoteFontStyle(element.id, 'underline', 'value'));
                                    }}
                                >
                                    <UnderlineTextIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Underline</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_ctx_note_font_style_strike', {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'note_font_styles',
                                        });
                                        handleSubMenuClick();
                                        dispatch(setNoteFontStyle(element.id, 'strikethrough', 'value'));
                                    }}
                                >
                                    <StrikethroughTextIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Strikethrough</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        );
    };



    // on update / on delete trigger menu
    const getOnTriggerMenu = (focusedLine, triggerType = 'update') => {
        if (!focusedLine) {
            return;
        }

        const isOnUpdateTrigger = triggerType == 'update';
        const { value: { onUpdateTrigger, onDeleteTrigger } } = focusedLine;
        const trigger = isOnUpdateTrigger ? onUpdateTrigger : onDeleteTrigger;

        const isMoreOptionSelected = ['no_action', 'set_default'].includes(trigger);

        const positionLeft = isOnUpdateTrigger ? -23 : 75;


        return (
            <div
                className={`menu on-trigger-menu`}
                style={{ top: '54px', position: 'absolute', left: `${133 - 53 + positionLeft}px` }}
            >
                <div className="controls-group">

                    <div className="control">
                        <button
                            className={`control-button`}
                            type="button"
                            aria-pressed="false"
                            onClick={() => {
                                trackEvent(`playground_on_${triggerType}_empty`, {
                                    page: 'playground',
                                    type: 'context',
                                    subtype: 'on_update_delete',
                                });
                                handleSubMenuClick();
                                if (isMoreBtnClicked) {
                                    setIsMoreBtnClicked(false);
                                }
                                if (trigger) {
                                    dispatch(setLineOnTrigger(focusedLine.id, triggerType, null));
                                }
                            }}
                            style={{ fontSize: '24px', fontWeight: 700 }}
                        >
                            <CircleNoneIcon />
                        </button>
                    </div>

                    <div className="control-divider"></div>

                    <div className="control">
                        <button
                            className={`control-button on-trigger-item ${trigger == 'cascade' ? 'selected' : ''}`}
                            type="button"
                            aria-pressed="false"
                            onClick={() => {
                                trackEvent(`playground_on_${triggerType}_cascade`, {
                                    page: 'playground',
                                    type: 'context',
                                    subtype: 'on_update_delete',
                                });
                                handleSubMenuClick();
                                if (isMoreBtnClicked) {
                                    setIsMoreBtnClicked(false);
                                }
                                if (trigger !== 'cascade') {
                                    dispatch(setLineOnTrigger(focusedLine.id, triggerType, 'cascade'));
                                }
                            }}
                        >
                            CASCADE
                        </button>
                    </div>

                    <div className="control-divider"></div>

                    <div className="control">
                        <button
                            className={`control-button on-trigger-item ${trigger == 'set_null' ? 'selected' : ''}`}
                            type="button"
                            aria-pressed="false"
                            onClick={() => {
                                trackEvent(`playground_on_${triggerType}_set_null`, {
                                    page: 'playground',
                                    type: 'context',
                                    subtype: 'on_update_delete',
                                });
                                handleSubMenuClick();
                                if (isMoreBtnClicked) {
                                    setIsMoreBtnClicked(false);
                                }
                                if (trigger !== 'set_null') {
                                    dispatch(setLineOnTrigger(focusedLine.id, triggerType, 'set_null'));
                                }
                            }}
                        >
                            SET NULL
                        </button>
                    </div>

                    <div className="control-divider"></div>

                    <div className="control">
                        <button
                            className={`control-button on-trigger-item ${trigger == 'restrict' ? 'selected' : ''}`}
                            type="button"
                            aria-pressed="false"
                            onClick={() => {
                                trackEvent(`playground_on_${triggerType}_restrict`, {
                                    page: 'playground',
                                    type: 'context',
                                    subtype: 'on_update_delete',
                                });
                                handleSubMenuClick();
                                if (isMoreBtnClicked) {
                                    setIsMoreBtnClicked(false);
                                }
                                if (trigger !== 'restrict') {
                                    dispatch(setLineOnTrigger(focusedLine.id, triggerType, 'restrict'));
                                }
                            }}
                        >
                            RESTRICT
                        </button>
                    </div>

                    <div className="control-divider"></div>

                    {/* closed more functions */}
                    {
                        !isMoreBtnClicked && !isMoreOptionSelected &&
                        <Fragment>
                            <div className="control">
                                <button
                                    className={`control-button more-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent(`playground_on_${triggerType}_more_funs`, {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'on_update_delete',
                                        });
                                        setIsMoreBtnClicked(true);
                                    }}
                                >...</button>
                            </div>
                        </Fragment>
                    }


                    {/* open more functions */}
                    {
                        (isMoreBtnClicked || isMoreOptionSelected) &&
                        <Fragment>

                            <div className="control">
                                <button
                                    className={`control-button on-trigger-item ${trigger == 'no_action' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent(`playground_on_${triggerType}_no_action`, {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'on_update_delete',
                                        });
                                        handleSubMenuClick();
                                        if (isMoreBtnClicked) {
                                            setIsMoreBtnClicked(false);
                                        }
                                        if (trigger !== 'no_action') {
                                            dispatch(setLineOnTrigger(focusedLine.id, triggerType, 'no_action'));
                                        }
                                    }}
                                >
                                    NO ACTION
                                </button>
                            </div>

                            <div className="control-divider"></div>

                            <div className="control">
                                <button
                                    className={`control-button on-trigger-item set-default ${trigger == 'set_default' ? 'selected' : ''}`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent(`playground_on_${triggerType}_set_default`, {
                                            page: 'playground',
                                            type: 'context',
                                            subtype: 'on_update_delete',
                                        });
                                        handleSubMenuClick();
                                        if (isMoreBtnClicked) {
                                            setIsMoreBtnClicked(false);
                                        }
                                        if (trigger !== 'set_default') {
                                            dispatch(setLineOnTrigger(focusedLine.id, triggerType, 'set_default'));
                                        }
                                    }}
                                >
                                    SET DEFAULT
                                </button>
                            </div>

                        </Fragment>
                    }

                </div>
            </div >
        )
    };

    // handle outside click logic
    const handleMenuClick = (item = null) => {
        const descriptionItems = ['area-description', 'line-description', 'table-description', 'column-description', 'note-description', 'pen-description'];

        if (item == clickedItem) {
            if (descriptionItems.includes(clickedItem)) {
                dispatch(disableElementDescriptionEditing())
            }

            setClickedItem(null);
        } else {
            if (descriptionItems.includes(clickedItem)) {
                dispatch(disableElementDescriptionEditing())
            }
            if (descriptionItems.includes(item)) {
                dispatch(enableElementDescriptionEditing())
            }

            setClickedItem(item);
        }
    };
    const handleSubMenuClick = () => {
        setClickedItem(null);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setClickedItem(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // handle mouse moves for hover/opacity for menu box
    // useEffect(() => {
    //     const handleMouseMove = (event) => {
    //         if (!menuRef.current) {
    //             return;
    //         }

    //         const HOVER_DISTANCE = 100;
    //         const mouseX = event.clientX;
    //         const mouseY = event.clientY;

    //         const menu = menuRef.current.getBoundingClientRect();
    //         const minX = menu.left - HOVER_DISTANCE;
    //         const maxX = menu.left + menu.width + HOVER_DISTANCE;
    //         const minY = menu.top - HOVER_DISTANCE;
    //         const maxY = menu.top + menu.height + HOVER_DISTANCE;

    //         if (
    //             mouseX >= minX &&
    //             mouseX <= maxX &&
    //             mouseY >= minY &&
    //             mouseY <= maxY
    //         ) {
    //             setIsHovered(true);
    //         } else {
    //             setIsHovered(false);
    //         }
    //     };

    //     document.addEventListener('mousemove', handleMouseMove);

    //     return () => {
    //         document.removeEventListener('mousemove', handleMouseMove);
    //     };
    // }, []);

    // handle change focusedElements, focusedLine => change view mode (table, column, codeBlock)
    function checkMenuState() {
        const focusedKeys = Object.keys(focusedElements);
        const focusedElementsCount = focusedKeys.length;

        let counter = { table: 0, note: 0, line: 0, 'pen-segment': 0 };

        for (let key in focusedElements) {
            const element = focusedElements[key];
            counter[element.type]++;
        }

        // console.log('Check Menu', counter)

        // isTable = is all tables (without lines)
        // isNote = is all notes (without lines)
        // isLine = is lines
        // isColumn =
        // isCodeBlock =
        // isDraw =
        // isGroup =

        // isTableNote =
        // isTableCodeBlock =
        // isMixed =


        // console.log('CONTEXT', focusedElementsCount, focusedGroupElements, focusedGroupAreas)

        // 1. no focused elements
        if (focusedElementsCount == 0) {
            // 1.1 focused line

            if (focusedLine) {
                setViewMode('line');

                // 1.2. no focused elements and no focused line
            } else if (focusedArea) {
                setViewMode('area');
            } else if (Object.keys(focusedGroupElements)?.length || Object.keys(focusedGroupAreas)?.length) {
                setViewMode('group');
            } else {
                setViewMode(null);
            }

            // 2. one focused element
        } else if (focusedElementsCount == 1) {
            // 2.1 focused one table
            if (counter.table) {
                // 2.1.1 with focused inside-element => focused column and focused table
                if (
                    focusedInsideElementRef.current?.elementId &&
                    focusedInsideElementRef.current?.insideElementId
                ) {
                    if (viewMode !== 'column' && isMoreBtnClicked) {
                        // handleMenuClick('column-more');
                        setIsMoreBtnClicked(false);
                    }
                    setViewMode('column');

                    // 2.1.2 no focused inside-element => focused table
                } else {
                    const focusedElementId = focusedElements[focusedKeys[0]];

                    let focusedElementIdBefore = null;
                    let focusedElementsCountBefore = 0;

                    if (focusedElementsRef.current) {
                        const keys = Object.keys(focusedElementsRef.current);
                        focusedElementsCountBefore = keys.length;
                        focusedElementIdBefore = focusedElementsRef.current[keys[0]];
                    }

                    if (focusedElementsCountBefore !== 1 || focusedElementIdBefore !== focusedElementId) {
                        setDragMenuDxDy({ dx: 0, dy: 0 });
                    }

                    // console.log('NEW TABLE SET', focusedElements, focusedElementsRef.current)
                    setViewMode('table');
                }

                // 2.2 focused one note
            } else if (counter.note) {
                setViewMode('note');
            } else if (counter['pen-segment']) {
                setViewMode('pen-segment');

                // 2.3 focused one other element
            } else {
                // other types of elements
            }

            // 3. many focused elements
        } else {
            // // 3.1 focused all tables
            // if (counter.table === focusedElementsCount) {
            // 	setViewMode('multi-table');

            // 	// 3.2 focused all notes
            // } else if (counter.note === focusedElementsCount) {
            // 	setViewMode('multi-note');

            // 3.3 focused mixed elements
            // } else {
            setViewMode('multi-elements');
            // }
        }
    }

    useLayoutEffect(() => {
        // console.log('2---', focusedElements);
        if (
            focusedInsideElement &&
            (!focusedElements ||
                !focusedElements[focusedInsideElement.elementId]?.value.columns[
                focusedInsideElement.insideElementId
                ])
        ) {
            // 1. update focused inside element
            focusedInsideElementRef.current = null;
        }

        setFocusedInsideElement(null);
        setClickedItem(null); // watch careful

        // 2. check menu state
        checkMenuState();

        focusedElementsRef.current = focusedElements;

    }, [focusedElements]);

    useLayoutEffect(() => {
        if (!focusedInsideElement) {
            setViewMode(null);
            // setClickedItem(null);
        }
        // 1. update focused inside element
        focusedInsideElementRef.current = focusedInsideElement;

        setFocusedInsideElement(focusedInsideElement);

        // 2. check menu state
        checkMenuState();

        return () => {
            dispatch(disableElementDescriptionEditing());
        }
    }, [focusedInsideElement]);


    useLayoutEffect(() => {
        if (isFocusedInsideElementEmpty && viewMode == 'column') {
            setViewMode('table');
        }
    }, [isFocusedInsideElementEmpty]);




    useLayoutEffect(() => {
        // 1. update focused inside element
        setFocusedInsideElement(null);

        // 2. check menu state
        checkMenuState();
    }, [focusedLine]);

    useLayoutEffect(() => {
        // 1. update focused inside element
        setFocusedInsideElement(null);

        // 2. check menu state
        checkMenuState();
    }, [focusedArea]);

    useLayoutEffect(() => {
        // 1. update focused inside element
        setFocusedInsideElement(null);

        // if (focusedGroupElements) {
        //     focusedGroupElementsCountRef.current = Object.keys(focusedGroupElements).length;
        // }
        // if (focusedGroupAreas) {
        //     focusedGroupAreasCountRef.current = Object.keys(focusedGroupAreas).length;
        // }

        // 2. check menu state
        checkMenuState();
    }, [focusedGroupElements, focusedGroupAreas]);

    useLayoutEffect(() => {
        // 1. update focused inside element
        console.log('view mode ---', viewMode);

        // 2. check menu state
        // checkMenuState();
    }, [viewMode]);


    useEffect(() => {
        const handleDragMenuMouseDown = (event) => {
            // check if press any button exept 'left mouse button' then return nothing
            if (event.button !== 0) {
                return;
            }

            const mouseX = event.clientX;
            const mouseY = event.clientY;

            setIsBtnDragMenuPressed(true);
            dragMenuStartXYRef.current = { x: event.clientX, y: event.clientY };
        };

        const handleDocumentMouseMove = (event) => {
            if (isBtnDragMenuPressed) {
                const mouseX = event.clientX;
                const mouseY = event.clientY;

                const dx = mouseX - dragMenuStartXYRef.current.x;
                const dy = mouseY - dragMenuStartXYRef.current.y;

                // dragMenuDxDyRef.current = {dx, dy};
                setDragMenuDxDy({
                    dx: dragMenuDxDy.dx + dx,
                    dy: dragMenuDxDy.dy + dy,
                });

                // count dx, dy
                // move menu.x & menu.y to dx, dy
                // coordinates = {x, y}
            }

            // if (isBtnDragMenuPressed && (Math.abs(mouseX - dragMenuStartXYRef.current.x) >= 20 || Math.abs(mouseY - dragMenuStartXYRef.current.y) >= 20)) {
            // 	dispatch(enableBtnNewTableGrab());
            // 	setIsBtnDragMenuPressed(false);
            // }
        };

        const handleDocumentClick = (event) => {
            // end of possible press, check first for no additional actions
            if (isBtnDragMenuPressed) {
                const mouseX = event.clientX;
                const mouseY = event.clientY;

                const dx = mouseX - dragMenuStartXYRef.current.x;
                const dy = mouseY - dragMenuStartXYRef.current.y;

                // click on the same place
                if (dx == 0 && dy == 0) {
                    setDragMenuDxDy({ dx: 0, dy: 0 });
                }


                setIsBtnDragMenuPressed(false);
            }
        };

        if (dragMenuRef.current) {
            dragMenuRef.current.addEventListener(
                'mousedown',
                handleDragMenuMouseDown
            );
            document.addEventListener('mousemove', handleDocumentMouseMove);
            document.addEventListener('click', handleDocumentClick);
        }

        return () => {
            if (dragMenuRef.current) {
                dragMenuRef.current.removeEventListener(
                    'mousedown',
                    handleDragMenuMouseDown
                );
                document.removeEventListener(
                    'mousemove',
                    handleDocumentMouseMove
                );
                document.removeEventListener('click', handleDocumentClick);
            }
        };
    }, [dispatch, isBtnDragMenuPressed, viewMode]);

    useEffect(() => {
        const handleKeyPress = (event) => {
            const isCtrl = isMac ? event.metaKey : event.ctrlKey;

            // const isOpenTextEditing = focusedInsideElementRedux || isEnabledElementDescriptionEditing;
            const isOpenTextEditing = focusedInsideElement && focusedInsideElement?.insideElementType === 'column';
            const isOpenHeaderEditing = focusedInsideElement && focusedInsideElement?.insideElementType === 'header';

            const isTextEditing =
                // isOpenTextEditing ||
                isModalDiagramDetailsEnabled ||
                isModalSupportEnabled;

            // Ignore events from disabled or read-only elements
            if (event.target.disabled || event.target.readOnly || isTextEditing)
                return;

            if (['note-description', 'pen-description', 'table-description', 'column-description', 'area-description', 'line-description'].includes(clickedItem)) {
                // -----------------------------------------------------------------------------
                // + [TAB] = [MOVE FOCUS ON INPUT/BUTTON]
                if (event.code === 'Tab' && !event.ctrlKey && !event.metaKey && !event.altKey) {
                    event.preventDefault();

                    if (document.activeElement === descriptionMenuInputRef.current) {
                        descriptionMenuButtonRef.current.focus();
                    } else {
                        descriptionMenuInputRef.current.focus();
                    }
                }
            } else if (clickedItem === 'enum') {
                // -----------------------------------------------------------------------------
                // + [TAB] = [MOVE FOCUS ON INPUT/BUTTON]
                if (event.code === 'Tab' && !event.ctrlKey && !event.metaKey && !event.altKey) {
                    event.preventDefault();

                    if (document.activeElement === enumValueMenuInputRef.current) {
                        enumValueMenuButtonRef.current.focus();
                    } else {
                        enumValueMenuInputRef.current.focus();
                    }
                }
            } else if (clickedItem === 'default-value') {
                // -----------------------------------------------------------------------------
                // + [TAB] = [MOVE FOCUS ON INPUT/BUTTON]
                if (event.code === 'Tab' && !event.ctrlKey && !event.metaKey && !event.altKey) {
                    event.preventDefault();

                    // if (document.activeElement === defaultValueMenuInputRef.current) {
                    //     defaultValueMenuButtonRef.current.focus();
                    // } else if (document.activeElement === defaultValueMenuButtonRef.current) {
                    //     defaultValueMenuInputRef.current.focus();
                    // } else {
                    //     defaultValueMenuInputRef.current.focus();
                    // }
                    if (document.activeElement === defaultValueMenuInputRef.current) {
                        defaultValueMenuButtonRef.current.focus();
                    } else {
                        defaultValueMenuInputRef.current.focus();
                    }
                }
            } else if (clickedItem === 'generated-value') {
                // -----------------------------------------------------------------------------
                // + [TAB] = [MOVE FOCUS ON INPUT/BUTTON]
                if (event.code === 'Tab' && !event.ctrlKey && !event.metaKey && !event.altKey) {
                    event.preventDefault();

                    // if (document.activeElement === generatedValueMenuInputRef.current) {
                    //     generatedValueMenuButtonRef.current.focus();
                    // } else {
                    //     if (generatedValueMenuInputRef.current) {
                    //         generatedValueMenuInputRef.current.focus();
                    //     }
                    // }

                    if (document.activeElement === generatedValueMenuInputRef.current) {
                        generatedValueMenuButtonRef.current.focus();
                    } else if (document.activeElement === generatedValueMenuButtonRef.current) {
                        generatedValueMenuInputRef.current.focus();
                        // } else {
                        //     generatedValueMenuInputRef.current.focus();
                    }

                }
            } else if (clickedItem === 'check-value') {
                // -----------------------------------------------------------------------------
                // + [TAB] = [MOVE FOCUS ON INPUT/BUTTON]
                if (event.code === 'Tab' && !event.ctrlKey && !event.metaKey && !event.altKey) {
                    event.preventDefault();

                    if (document.activeElement === checkValueMenuInputRef.current) {
                        checkValueMenuButtonRef.current.focus();
                    } else {
                        checkValueMenuInputRef.current.focus();
                    }
                }
            } else if (isOpenTextEditing) {
                // + [CTRL + 1]
                if (
                    event.code === 'Digit1' && isCtrl &&
                    !event.shiftKey &&
                    !event.altKey
                ) {
                    event.stopPropagation();
                    event.preventDefault();
                    handleSubMenuClick();

                    trackEvent('playground_shortcut_key_pk', {
                        page: 'playground',
                        type: 'shortcuts',
                    });

                    if (
                        focusedInsideElementRef.current?.elementId &&
                        focusedInsideElementRef.current?.insideElementId
                    ) {
                        const isPK =
                            focusedInsideElementRef.current?.insideElement
                                ?.isPK;

                        const newValue = isPK ? null : 'pk';
                        dispatch(
                            setColumnKey(
                                focusedInsideElementRef.current?.elementId,
                                focusedInsideElementRef.current
                                    ?.insideElementId,
                                newValue
                            )
                        );
                    }
                }
                // + [CTRL + 2]
                else if (
                    event.code === 'Digit2' && isCtrl &&
                    !event.shiftKey &&
                    !event.altKey
                ) {
                    event.preventDefault();
                    event.stopPropagation();
                    handleSubMenuClick();

                    trackEvent('playground_shortcut_key_fk', {
                        page: 'playground',
                        type: 'shortcuts',
                    });

                    if (
                        focusedInsideElementRef.current?.elementId &&
                        focusedInsideElementRef.current?.insideElementId
                    ) {
                        const isFK =
                            focusedInsideElementRef.current?.insideElement
                                ?.isFK;

                        const newValue = isFK ? null : 'fk';
                        dispatch(
                            setColumnKey(
                                focusedInsideElementRef.current?.elementId,
                                focusedInsideElementRef.current
                                    ?.insideElementId,
                                newValue
                            )
                        );
                    }
                }
                // // + [CTRL + 3]
                // else if (
                //     event.code === 'Digit3' && isCtrl &&
                //     !event.shiftKey &&
                //     !event.altKey
                // ) {
                //     event.preventDefault();
                //     event.stopPropagation();
                //     handleSubMenuClick();

                //     if (
                //         focusedInsideElementRef.current?.elementId &&
                //         focusedInsideElementRef.current?.insideElementId
                //     ) {
                //         dispatch(
                //             setColumnNN(
                //                 focusedInsideElementRef.current?.elementId,
                //                 focusedInsideElementRef.current?.insideElementId
                //             )
                //         );
                //     }
                // }
                // // + [CTRL + 4]
                // else if (
                //     event.code === 'Digit4' && isCtrl &&
                //     !event.shiftKey &&
                //     !event.altKey
                // ) {
                //     event.preventDefault();
                //     event.stopPropagation();
                //     handleSubMenuClick();

                //     if (
                //         focusedInsideElementRef.current?.elementId &&
                //         focusedInsideElementRef.current?.insideElementId
                //     ) {
                //         const indexType =
                //             focusedInsideElementRef.current?.insideElement
                //                 ?.index?.type;

                //         const newValue =
                //             indexType === 'regular' ? null : 'regular';
                //         dispatch(
                //             setColumnIndex(
                //                 focusedInsideElementRef.current?.elementId,
                //                 focusedInsideElementRef.current
                //                     ?.insideElementId,
                //                 newValue
                //             )
                //         );
                //     }
                // }
                // // + [CTRL + 5]
                // else if (
                //     event.code === 'Digit5' && isCtrl &&
                //     !event.shiftKey &&
                //     !event.altKey
                // ) {
                //     event.preventDefault();
                //     event.stopPropagation();
                //     handleSubMenuClick();

                //     if (
                //         focusedInsideElementRef.current?.elementId &&
                //         focusedInsideElementRef.current?.insideElementId
                //     ) {
                //         const indexType =
                //             focusedInsideElementRef.current?.insideElement
                //                 ?.index?.type;

                //         const newValue =
                //             indexType === 'unique' ? null : 'unique';
                //         dispatch(
                //             setColumnIndex(
                //                 focusedInsideElementRef.current?.elementId,
                //                 focusedInsideElementRef.current
                //                     ?.insideElementId,
                //                 newValue
                //             )
                //         );
                //     }
                // }
                // // + [CTRL + 6]
                // else if (
                //     event.code === 'Digit6' && isCtrl &&
                //     !event.shiftKey &&
                //     !event.altKey
                // ) {
                //     event.preventDefault();
                //     event.stopPropagation();
                //     handleSubMenuClick();

                //     if (
                //         focusedInsideElementRef.current?.elementId &&
                //         focusedInsideElementRef.current?.insideElementId
                //     ) {
                //         const indexType =
                //             focusedInsideElementRef.current?.insideElement
                //                 ?.index?.type;

                //         const newValue =
                //             indexType === 'composite' ? null : 'composite';
                //         dispatch(
                //             setColumnIndex(
                //                 focusedInsideElementRef.current?.elementId,
                //                 focusedInsideElementRef.current
                //                     ?.insideElementId,
                //                 newValue
                //             )
                //         );
                //     }
                // }
                // // + [CTRL + 7]
                // else if (
                //     event.code === 'Digit7' && isCtrl &&
                //     !event.shiftKey &&
                //     !event.altKey
                // ) {
                //     event.preventDefault();
                //     event.stopPropagation();
                //     handleSubMenuClick();

                //     if (
                //         focusedInsideElementRef.current?.elementId &&
                //         focusedInsideElementRef.current?.insideElementId
                //     ) {
                //         const indexType =
                //             focusedInsideElementRef.current?.insideElement
                //                 ?.index?.type;

                //         const newValue =
                //             indexType === 'fullText' ? null : 'fullText';
                //         dispatch(
                //             setColumnIndex(
                //                 focusedInsideElementRef.current?.elementId,
                //                 focusedInsideElementRef.current
                //                     ?.insideElementId,
                //                 newValue
                //             )
                //         );
                //     }
                // }
                // // + [ESC]
                // else if (event.code === 'Escape') {
                //     event.preventDefault();
                //     event.stopPropagation();
                //     // handleMenuClick();

                //     if (clickedItem) {
                //         handleSubMenuClick();
                //     } else {
                //         dispatch(clickEscape());
                //     }
                //     console.log('Context Menu NEW Escape', clickedItem)
                // }

            } else {
                // -----------------------------------------------------------------------------
                // +/- [DELETE] = [OPEN DELETE CONTEXT MENU / OR DELETE ELEMENT]
                if (
                    event.code === 'Delete' &&
                    !event.ctrlKey &&
                    !event.metaKey &&
                    !event.shiftKey &&
                    !event.altKey
                ) {
                    if (isOpenHeaderEditing) {
                        // event.preventDefault();
                        // nothing
                    } else if (['table'].includes(viewMode)) {
                        trackEvent('playground_shortcut_delete_table', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        handleMenuClick('delete-element');
                    } else if (['multi-elements'].includes(viewMode)) {
                        const isFocusedElementsHasTable = Object.values(focusedElements).some((element) => element.type === 'table');
                        if (isFocusedElementsHasTable) {
                            trackEvent('playground_shortcut_delete_multi_elements', {
                                page: 'playground',
                                type: 'shortcuts',
                            });
                            handleMenuClick('delete-element');
                        } else {
                            trackEvent('playground_shortcut_delete_elements', {
                                page: 'playground',
                                type: 'shortcuts',
                            });
                            handleMenuClick();
                            dispatch(deleteElements());
                            setViewMode(null);
                        }
                    } else if (
                        viewMode === 'note' ||
                        viewMode === 'pen-segment'
                    ) {
                        trackEvent('playground_shortcut_delete_elements', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        handleMenuClick();
                        dispatch(deleteElements());
                        setViewMode(null);
                    } else if (viewMode === 'area') {
                        trackEvent('playground_shortcut_delete_area', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        handleMenuClick();
                        dispatch(deleteFocusedArea());
                        setViewMode(null);
                    } else if (viewMode === 'line') {
                        trackEvent('playground_shortcut_delete_line', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        handleMenuClick();
                        dispatch(deleteLine());
                        setViewMode(null);
                    } else if (viewMode === 'group') {
                        trackEvent('playground_shortcut_delete_group', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        // handleMenuClick();
                        // dispatch(deleteFocusedGroup());
                        handleMenuClick('delete-element');
                    }
                }
                // -----------------------------------------------------------------------------
                // +/- [CTRL + DELETE] = [NOW => DELETE ELEMENT] [SHOULD BE => OPEN DELETE CONTEXT MENU]
                else if (
                    event.code === 'Delete' && isCtrl &&
                    !event.shiftKey &&
                    !event.altKey
                ) {
                    event.preventDefault();
                    if (isOpenHeaderEditing) {
                        trackEvent('playground_shortcut_delete_element', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        handleMenuClick('delete-element');
                    }
                }
                // + [ESC]
                else if (event.code === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    // handleMenuClick();
                    handleSubMenuClick();
                    // console.log('Context Menu Escape', clickedItem)
                }
                // + [ENTER] = [DELETE ELEMENT WHEN OPEN DELETE-MENU]
                // [WHEN HEADER EDITING] [FOCUS ON FIRST COLUMN / ADD NEW FIRST COLUMN]
                else if (
                    (event.code === 'Enter' || event.code === 'NumpadEnter') &&
                    !event.ctrlKey &&
                    !event.metaKey &&
                    !event.shiftKey &&
                    !event.altKey
                ) {
                    event.preventDefault();

                    if (isOpenHeaderEditing) {
                        if (clickedItem === 'delete-element') {
                            trackEvent('playground_shortcut_delete_element', {
                                page: 'playground',
                                type: 'shortcuts',
                            });
                            handleSubMenuClick();
                            dispatch(deleteElements());
                            setViewMode(null);
                        } else if (!clickedItem) {
                            dispatch(addNewFirstColumn(focusedInsideElement.elementId, true));
                        }
                    } else if (viewMode === 'group') {
                        trackEvent('playground_shortcut_delete_group', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        handleSubMenuClick();
                        dispatch(deleteFocusedGroup());
                        setViewMode(null);
                    } else {
                        if (clickedItem === 'delete-element') {
                            trackEvent('playground_shortcut_delete_element', {
                                page: 'playground',
                                type: 'shortcuts',
                            });
                            handleSubMenuClick();
                            dispatch(deleteElements());
                            setViewMode(null);
                        }
                    }
                }
                // + [CTRL + ENTER] = [ADD NEW FIRST COLUMN WHEN HEADER EDITING]
                else if (
                    (event.code === 'Enter' || event.code === 'NumpadEnter') && isCtrl &&
                    !event.altKey
                ) {
                    event.preventDefault();
                    if (isOpenHeaderEditing && !clickedItem) {
                        trackEvent('playground_shortcut_add_first_column', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        dispatch(
                            addNewFirstColumn(
                                focusedInsideElement.elementId,
                                false
                            )
                        );
                    }
                    // -----------------------------------------------------------------------------
                }

                // +/- [CTRL + C] = [DUPLICATE ELEMENT]
                else if (
                    event.code === 'KeyC' && isCtrl &&
                    !event.shiftKey &&
                    !event.altKey
                ) {
                    if (isOpenHeaderEditing) {
                        // event.preventDefault();
                        // nothing
                    } else if (
                        [
                            'table',
                            'note',
                            'pen-segment',
                            'multi-elements',
                        ].includes(viewMode)
                    ) {
                        trackEvent('playground_shortcut_duplicate_elements', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        dispatch(duplicateElements());
                        setViewMode(null);
                    } else if (viewMode == 'area') {
                        trackEvent('playground_shortcut_duplicate_area', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        dispatch(duplicateFocusedArea());
                        setViewMode(null);
                    }
                }
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [
        focusedInsideElement,
        isModalDiagramDetailsEnabled,
        isModalSupportEnabled,
        clickedItem,
        viewMode,
    ]);



    useEffect(() => {
        setDragMenuDxDy({ dx: 0, dy: 0 });
        return () => { };
    }, [viewMode]);

    const isShowedMenu = isContextMenuShowed && boardViewMode === 'full' && !isNotElementInViewPort;

    return (
        <div
            ref={menuRef}
            className={`context-menu ${isHovered || isContextMenuVisible ? 'mouse-hovered' : ''}`}
            style={positionMenuStyle}
        >
            {!isContextMenuShowed && viewMode && wrappedMenu}

            {isShowedMenu && viewMode === 'table' && getTableMenu(focusedElements)}
            {isShowedMenu && viewMode === 'column' && getColumnMenu()}

            {isShowedMenu && viewMode === 'line' && getLineMenu(focusedLine)}
            {isShowedMenu && viewMode === 'area' && getAreaMenu(focusedArea)}


            {isShowedMenu && clickedItem === 'enum' && <EnumMenu />}

            {/* ------------------------------------------------------------ */}

            {isShowedMenu && viewMode === 'note' && getNoteMenu(focusedElements)}

            {isShowedMenu && viewMode === 'pen-segment' && getPenSegmentMenu(focusedElements)}

            {isShowedMenu && viewMode === 'multi-elements' && getMultiElementsMenu(focusedElements)}
            {isShowedMenu && viewMode === 'group' && getGroupMenu(focusedGroupElements, focusedGroupAreas)}

            {/* {isShowedMenu && clickedItem === 'enum' && <EnumMenu />} */}
            {isShowedMenu && clickedItem === 'default-value' && <DefaultValueMenu />}

            {isShowedMenu && clickedItem === 'generated-value' && <GeneratedValueMenu />}
            {isShowedMenu && clickedItem === 'check-value' && <CheckValueMenu />}

            {isShowedMenu && clickedItem === 'note-description' && <DescriptionMenu type={'note'} />}
            {isShowedMenu && clickedItem === 'pen-description' && <DescriptionMenu type={'pen'} />}
            {isShowedMenu && clickedItem === 'table-description' && <DescriptionMenu type={'table'} />}

            {isShowedMenu && clickedItem === 'column-description' && <DescriptionMenu type={'column'} />}

            {isShowedMenu && clickedItem === 'area-description' && <DescriptionMenu type={'area'} />}
            {isShowedMenu && clickedItem === 'line-description' && <DescriptionMenu type={'line'} />}


            {isShowedMenu && clickedItem === 'on-update-trigger' && getOnTriggerMenu(focusedLine, 'update')}
            {isShowedMenu && clickedItem === 'on-delete-trigger' && getOnTriggerMenu(focusedLine, 'delete')}

            {isShowedMenu && clickedItem === 'key' && getKeyMenu()}
            {isShowedMenu && clickedItem === 'index' && getIndexMenu()}

            {isShowedMenu && clickedItem === 'left-line-connector' && getleftLineConnectorMenu(focusedLine)}
            {isShowedMenu && clickedItem === 'right-line-connector' && getRightLineConnectorMenu(focusedLine)}
            {isShowedMenu && clickedItem === 'line-solid-type' && getLineSolidTypeMenu(focusedLine)}

            {isShowedMenu && clickedItem === 'element-borders' && getElementBorderMenu(focusedElements, focusedArea)}
            {isShowedMenu && clickedItem === 'color-picker' && getColorPickerMenu(focusedElements, focusedLine, focusedArea)}

            {isShowedMenu && clickedItem === 'align' && getNoteAlignmentMenu(focusedElements)}
            {isShowedMenu && clickedItem === 'font-styles' && getNoteFontStylesMenu(focusedElements)}

            {isShowedMenu && clickedItem === 'delete-element' && getDeleteElementMenu(focusedElements, focusedGroupElements, focusedGroupAreas)}
            {/* {isShowedMenu && clickedItem === 'delete-column' && deleteColumnMenu} */}
            {/* {isShowedMenu && clickedItem === 'delete-line' && deleteLineMenu} */}
        </div>
    );
};

export default ContextMenu;
